define(["dojo-proxy-loader?name=dojo/_base/declare!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dijit/_WidgetBase", "dijit/_TemplatedMixin", "dijit/_FocusMixin", "dojo-proxy-loader?name=dojo/_base/array!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/query!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/on!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/_base/lang!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-form!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-geometry!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-construct!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-style!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-attr!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo/html", "dojo-proxy-loader?name=dojo/Evented!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo/promise/all", "dojo-proxy-loader?name=dojo/Deferred!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/sniff!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo/cookie", "dojox/html/entities", "dojox/widget/Toaster", "mojo/widgets/_CustomStyleRulesMixin", "mojo/page/request", "dojo-proxy-loader?name=dojo/request/xhr!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module"], function (declare, _WidgetBase, _TemplatedMixin, _FocusMixin, array, query, on, lang, domForm, domGeom, domConstruct, domStyle, domAttr, html, Evented, all, Deferred, has, cookie, entities, Toaster, _CustomStyleRulesMixin, request, xhr) {
  var translations = {};
  var globalConfig = {};
  var _ValidationTypes = declare([], {
    /* Field (one or more inputs) Validation Methods */
    isEmpty: function () {
      var valid;
      array.forEach(this.inputs, lang.hitch(this, function (input) {
        if (input.type === "radio" || input.type === "checkbox" || input.tagName.toLowerCase() === "option") {
          valid = typeof valid === "boolean" ? valid && !this._checked(input) : !this._checked(input);
        } else {
          valid = typeof valid === "boolean" ? valid && this._empty(input.value) : this._empty(input.value);
        }
      }));
      return valid;
    },
    isValidSMSPhoneNumber: function () {
      return true;
    },
    isSMSTermsAcknowledged: function () {
      //if required - the SMSPHONE should have 2 input fields
      //1 - the text input for the number
      //2 - the acknowldedge checkbox (always 2nd)
      if (this.inputs.length === 2 && this.inputs[1].type === "checkbox") {
        return this.inputs[1].checked;
      }
      return true;
    },
    // At least one option is selected. Use array.some so we can return true as soon as we find a checked input.
    isChecked: function () {
      array.some(this.inputs, lang.hitch(this, function (input) {
        if (this._checked(input)) {
          return true;
        }
      }));
      return false;
    },
    // An email field contains one input
    isEmail: function () {
      return this._email(this.inputs[0].value);
    },
    // A phone field contains three inputs: area, detail1 and detail2
    isPhone: function () {
      return this._phone(this.phoneAreaNode.value, this.phoneDetail1Node.value, this.phoneDetail2Node.value);
    },
    isUrl: function () {
      return this._url(this.inputs[0].value);
    },
    isNumber: function () {
      return this._number(this.inputs[0].value);
    },
    isBirthday: function () {
      return this._monthDigits(this.monthNode.value) && this._dayDigits(this.dayNode.value);
    },
    isDate: function () {
      return this._yearDigits(this.yearNode.value) && this._monthDigits(this.monthNode.value) && this._dayDigits(this.dayNode.value);
    },
    isAddress: function () {
      return !this._empty(this.address1Node.value) && !this._empty(this.cityNode.value) && !this._empty(this.stateNode.value) && this._checked(query(":checked", this.countrySelectNode)[0]) && !this._empty(this.zipNode.value);
    },
    /* Single Input Validation Methods */
    _required: function (value) {
      return value.trim().length > 0;
    },
    _empty: function (value) {
      return value === null || typeof value === "undefined" || value === "";
    },
    _email: function (value) {
      return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
    },
    // YYYY [all the digits, i.e. 2012]
    _yearDigits: function (value) {
      return this._digits(value) && this._range(value, [1, 9999]);
    },
    // MM [01 (January) to 12 (December)]
    _monthDigits: function (value) {
      return this._digits(value) && this._range(value, [1, 12]);
    },
    // DD [01 to 31]
    _dayDigits: function (value) {
      return this._digits(value) && this._range(value, [1, 31]);
    },
    _digits: function (value) {
      return /^\d+$/.test(value);
    },
    _range: function (value, param) {
      return value >= param[0] && value <= param[1];
    },
    _number: function (value) {
      return this._digits(value) && !isNaN(value);
    },
    _minlength: function (value, param) {
      return value.trim().length >= param;
    },
    _maxlength: function (value, param) {
      return value.trim().length <= param;
    },
    _exactLength: function (value, param) {
      return value.trim().length === param;
    },
    // US zip code
    _zipcode: function (value) {
      return /^\d{5}-\d{4}$|^\d{5}$/.test(value);
    },
    _url: function (value) {
      return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
    },
    /* Custom Validation Methods */
    _phone: function (area, detail1, detail2) {
      return this._digits(area) && this._digits(detail1) && this._digits(detail2) && this._exactLength(area, 3) && this._exactLength(detail1, 3) && this._exactLength(detail2, 4);
    },
    _checked: function (node) {
      return node.checked || node.selected && !this._empty(node.value);
    },
    /* Utility Methods */
    _checkable: function (node) {
      return /radio|checkbox/i.test(node.type);
    }
  });
  var _ValidationMixin = declare([_FocusMixin, _ValidationTypes], {
    // TODO: Allow users to supply custom validation messages?

    _onBlur: function () {
      this.inherited(arguments);
      this.validateField();
    },
    validateField: function () {
      var errors = [];
      var valid, message;
      if (this.required) {
        valid = !this.isEmpty(); // TODO: What about the address field which has inputs (e.g., address2) that can be empty?

        if (!valid) {
          errors.push(translations["9303c9bd4f8178680dc382adbfcd62af"]);
        }
        // In english, translates to "This field is required."
      }
      switch (this.validateAsType) {
        case "email":
          valid = this.isEmpty() || this.isEmail();
          message = translations["b5bccda6d3a04e1d8f79846355290435"];
          // In english, translates to  "Please enter a valid email address."; // TODO: Make this part of the form widget?
          break;
        case "address":
          valid = this.isEmpty() || this.isAddress();
          message = translations["65072e37cef3c8e8fe8873937664c67c"];
          // In english, translates to  "Please enter a valid address.";
          break;
        case "phone":
          valid = this.isEmpty() || this.isPhone();
          message = translations["7724076d0ccc93dbb00326dbedfeee14"];
          // In english, translates to  "Please enter a valid phone number.";
          break;
        case "smsphone":
          if ((this.includeAgeGatingDob || this.ageGatingEnabled) && this.required && this.isEmpty()) {
            valid = false;
            message = translations["9303c9bd4f8178680dc382adbfcd62af"];
            break;
          }
          valid = this.isValidSMSPhoneNumber();
          message = translations["7724076d0ccc93dbb00326dbedfeee14"];
          //Phone validation passed - now checking acknowledge checkbox if required
          if (valid && this.required && !this.smsCheckboxUpdatesEnabled) {
            if (!this.isSMSTermsAcknowledged()) {
              valid = false;
              message = "Must acknowledge SMS terms.";
            }
          }
          break;
        case "url":
          valid = this.isEmpty() || this.isUrl(); // TODO: image url validation?
          message = translations["2918dd459b068924e2b6d6df3faa2a47"];
          // In english, translates to  "Please enter a valid url.";
          break;
        case "number":
          valid = this.isEmpty() || this.isNumber();
          message = translations["aae0933b5535a899ca6a790ef963de38"];
          // In english, translates to  "Please enter a valid number.";
          break;
        case "birthday":
          valid = this.isEmpty() || this.isBirthday();
          message = translations["08e0d7dddecd2fbebae22aa3f9d5241d"];
          // In english, translates to  "Please enter a valid birthday.";
          break;
        case "date":
          valid = this.isEmpty() || this.isDate();
          message = translations["773fcd7a2070fcf96c72ea6540c77eb8"];
          // In english, translates to  "Please enter a valid date.";
          break;
        case "radiocheckbox":
        case "select":
          valid = this.isEmpty() || this.isChecked();
        default:
          valid = true;
        // NOTE: generic text inputs are valid by default
      }
      if (!valid) {
        errors.push(message);
      }
      this.setFieldValidationStatus(errors);
      return errors;
    },
    setFieldValidationStatus: function (errors) {
      if (errors.length > 0) {
        this.setFieldAsInvalid(errors[0]);
      } else {
        this.setFieldAsValid();
      }
    },
    setFieldAsInvalid: function (message) {
      this.inputs.addClass("invalid").removeClass("valid");
      html.set(this.errorsNode, message);
      domStyle.set(this.errorsNode, "display", "block");
    },
    setFieldAsValid: function () {
      this.inputs.addClass("valid").removeClass("invalid");
      domStyle.set(this.errorsNode, "display", "none");
    },
    resetField: function () {
      this.inputs.removeClass("valid").removeClass("invalid");
      domStyle.set(this.errorsNode, "display", "none");
    },
    _getErrorsNode: function () {
      var node = query(".invalid-error", this.domNode)[0];
      if (!node) {
        node = domConstruct.place('<div class="invalid-error"></div>', this.domNode);
      }
      return node;
    }
  });
  var _BaseField = declare([_WidgetBase, _TemplatedMixin, _ValidationMixin], {
    required: false,
    inputs: [],
    errorsNode: null,
    postCreate: function () {
      this.inputs = query("input:not([type='hidden']), select option", this.domNode);
      this.errorsNode = this._getErrorsNode();
    }
  });
  var SmsPhoneField = declare([_BaseField], {
    templateString: "<div class=\"field-wrapper sms-phone-field\">" + "<div data-dojo-attach-point=\"dobContainer\"></div>" + "<div data-dojo-attach-point=\"smsLabel\" style=\"display: flex; justify-content: space-between;\">" + "<label for=\"mc-${name}\">${label}</label>" + "</div>" + "<div data-dojo-attach-point=\"smsInputWrapper\">" + "<input type=\"text\" name=\"${name}\" value=\"\" id=\"mc-${name}\" data-dojo-attach-point=\"smsPhoneInput\"/>" + "</div>" + "<div id=\"sms-terms-container\" style=\"display: flex;\">" + "<div data-dojo-attach-point=\"smsLegal\" style=\" " + (this.formsMultiCountryFastFollowsEnabled ? "margin-bottom: 20px;" : "margin-top: 0 !important;") + "font-size: 12px;line-height: 140%;\"></div>" + "</div>" + "</div>",
    validateAsType: "smsphone",
    legalCopy: "",
    smsProgramData: null,
    defaultCountryCode: null,
    multiCountryEnabled: "",
    formsMultiCountryFastFollowsEnabled: "",
    legaleseVersionCaptureAndSaveEnabled: "",
    smsNotRequiredRemoveCountryCodeEnabled: "",
    landingPagesInputStylesFixEnabled: "",
    europeanSmsExpansionEnabled: "",
    smsCheckboxUpdatesEnabled: "",
    countryNames: [],
    includeAgeGatingDob: false,
    // Mirrors PHP aorg.age_gating_enabled flag.
    ageGatingEnabled: false,
    dobDateFormat: "",
    dobCountryCode: "",
    dobFieldName: "",
    dobLabel: "",
    dobRequired: false,
    // When true, DOB becomes required dynamically once SMS has a non-empty value.
    dobRequiredIfSmsEntered: false,
    dobUseCase: "",
    _dobInputNode: null,
    _dobErrorNode: null,
    // Treat country-code prefix-only value as empty when age-gating is on.
    isEmpty: function () {
      if ((this.includeAgeGatingDob || this.ageGatingEnabled) && this.smsPhoneInput) {
        var currentValue = (this.smsPhoneInput.value || "").trim();
        var prefix = (this.smsPhoneInput.getAttribute("data-current-prefix") || "").trim();
        if (prefix && currentValue === prefix) {
          return true;
        }
      }
      return this.inherited(arguments);
    },
    // Age-gating: own a dedicated SMS error node placed after the legal copy so it isn't reused by the DOB invalid-error div.
    _getErrorsNode: function () {
      if (!this.includeAgeGatingDob && !this.ageGatingEnabled) {
        return this.inherited(arguments);
      }
      if (this._smsErrorNode) {
        return this._smsErrorNode;
      }
      var termsContainer = this.smsLegal && this.smsLegal.parentNode ? this.smsLegal.parentNode : null;
      var anchor = termsContainer || this.smsInputWrapper || this.domNode;
      var position = termsContainer || this.smsInputWrapper ? "after" : "last";
      this._smsErrorNode = domConstruct.create("div", {
        "class": "invalid-error",
        style: "display: none; position: relative; top: 0; margin-top: -12px; margin-bottom: 20px;"
      }, anchor, position);
      return this._smsErrorNode;
    },
    validateField: function () {
      var errors = this.inherited(arguments);
      if (this._dobInputNode) {
        var val = this._dobInputNode.value.trim();
        var dobErrors = [];

        // Required up-front, or dynamically once SMS has a value.
        var smsHasValue = !this.isEmpty();
        var dobIsRequired = this.dobRequired || this.dobRequiredIfSmsEntered && smsHasValue;
        if (dobIsRequired && val === "") {
          dobErrors.push(translations["9303c9bd4f8178680dc382adbfcd62af"]);
        } else if (val !== "") {
          var parts = val.split("/");
          var valid = false;
          if (parts.length === 3) {
            var a = parseInt(parts[0], 10);
            var b = parseInt(parts[1], 10);
            var yr = parseInt(parts[2], 10);
            var fmt = this._dobInputNode.getAttribute("data-date-format");
            var month = fmt === "DD/MM/YYYY" ? b : a;
            var day = fmt === "DD/MM/YYYY" ? a : b;
            var currentYear = new Date().getFullYear();
            var rangeOk = !isNaN(month) && !isNaN(day) && !isNaN(yr) && month >= 1 && month <= 12 && day >= 1 && day <= 31 && yr >= currentYear - 150 && yr <= currentYear && parts[2].length === 4;
            // Calendar roundtrip: rejects Feb 29 in non-leap years, Apr/Jun/Sep/Nov 31, etc.,
            // while accepting Feb 29 in real leap years.
            var calendarOk = false;
            if (rangeOk) {
              var d = new Date(yr, month - 1, day);
              calendarOk = d.getFullYear() === yr && d.getMonth() === month - 1 && d.getDate() === day;
            }
            valid = rangeOk && calendarOk;
          }
          if (!valid) {
            dobErrors.push(translations["773fcd7a2070fcf96c72ea6540c77eb8"]);
          }
        }
        if (dobErrors.length > 0) {
          if (this._dobErrorNode) {
            this._dobErrorNode.innerHTML = dobErrors[0];
            this._dobErrorNode.style.display = "block";
          }
          this._dobInputNode.classList.add("invalid");
          this._dobInputNode.classList.remove("valid");
          errors = errors.concat(dobErrors);
        } else {
          if (this._dobErrorNode) {
            this._dobErrorNode.style.display = "none";
          }
          this._dobInputNode.classList.remove("invalid");
          this._dobInputNode.classList.add("valid");
        }
      }
      return errors;
    },
    _builAckNode: function () {
      var style = this.formsMultiCountryFastFollowsEnabled ? "margin-top: -5px;" : "margin: 0 !important;";
      return "<label class=\"checkbox\" style=\" " + style + "\">" + "<input type=\"checkbox\" name=\"mc-SMSPHONE-ack\" id=\"mc-SMSPHONE-ack\" value=\"true\" />" + "<span>&nbsp;</span>" + "</label>";
    },
    _getFlagEmoji: function (countryCode) {
      if (!countryCode || countryCode.length !== 2) {
        return "";
      }
      if (!countryCode || typeof countryCode !== "string" || countryCode.length !== 2) {
        return "";
      }
      var code = countryCode.toUpperCase().trim();
      var firstChar = code.charCodeAt(0) - "A".charCodeAt(0) + 0x1F1E6;
      var secondChar = code.charCodeAt(1) - "A".charCodeAt(0) + 0x1F1E6;
      return String.fromCodePoint(firstChar) + String.fromCodePoint(secondChar);
    },
    postCreate: function () {
      var legalNode;
      var smsPrefix;

      // NOTE: masking logic duplicated in PagesSignupFormBlock.js
      if (this.includeAgeGatingDob && this.dobContainer) {
        var dobName = this.dobFieldName || "MC_AGE_GATING_DOB";
        var dobCC = this.dobCountryCode || "";
        if (!dobCC && this.smsProgramData && this.smsProgramData.length > 0) {
          dobCC = this.smsProgramData[0].countryCode || "";
        }
        var dobFmt = this.dobDateFormat || "MM/DD/YYYY";
        if (dobCC) {
          dobFmt = dobCC.toUpperCase() === "US" ? "MM/DD/YYYY" : "DD/MM/YYYY";
        }
        var dobLbl = this.dobLabel || "Date of Birth";
        var dobReq = this.dobRequired;
        var dobWrapper = domConstruct.create("div", {
          "class": "field-wrapper age-gating-dob"
        }, this.dobContainer);
        var dobLabel = domConstruct.create("label", {
          "for": "mc-" + dobName
        }, dobWrapper);
        dobLabel.textContent = dobLbl;
        var dobInputsDiv = domConstruct.create("div", null, dobWrapper);
        domConstruct.create("input", {
          type: "hidden",
          name: "MC_AGE_GATING_DOB_country",
          value: dobCC
        }, dobInputsDiv);
        domConstruct.create("input", {
          type: "hidden",
          name: "MC_AGE_GATING_USE_CASE",
          value: this.dobUseCase || ""
        }, dobInputsDiv);
        var dobInputAttrs = {
          "class": "age-gating-dob-input",
          type: "text",
          inputmode: "numeric",
          autocomplete: "bday",
          maxlength: "10",
          placeholder: dobFmt,
          name: dobName,
          value: "",
          id: "mc-" + dobName,
          "data-date-input": "ageGatingDob",
          "data-date-format": dobFmt
        };
        if (dobReq) {
          dobInputAttrs.required = "required";
        }
        var dobInput = domConstruct.create("input", dobInputAttrs, dobInputsDiv);
        this._dobInputNode = dobInput;
        this._dobErrorNode = domConstruct.create("div", {
          "class": "invalid-error",
          style: "display:none"
        }, dobWrapper);
        dobInput.addEventListener("input", function () {
          var digits = dobInput.value.replace(/\D/g, "").slice(0, 8);
          var masked = "";
          if (digits.length <= 2) {
            masked = digits;
          } else if (digits.length <= 4) {
            masked = digits.slice(0, 2) + "/" + digits.slice(2);
          } else {
            masked = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4);
          }
          if (masked !== dobInput.value) {
            dobInput.value = masked;
          }
        });
        dobInput.addEventListener("paste", function (e) {
          e.preventDefault();
          var pasted = e.clipboardData && e.clipboardData.getData ? e.clipboardData.getData("text") : "";
          var digits = pasted.replace(/\D/g, "").slice(0, 8);
          if (digits.length <= 2) {
            dobInput.value = digits;
          } else if (digits.length <= 4) {
            dobInput.value = digits.slice(0, 2) + "/" + digits.slice(2);
          } else {
            dobInput.value = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4);
          }
        });
      }
      var legalRequiredFallback = this.legal && this.legal.required ? this.legal.required : "";
      var legalOptionalFallback = this.legal && this.legal.optional ? this.legal.optional : "";
      if (this.smsProgramData) {
        if (this.multiCountryEnabled) {
          var countrySelectId = "country-select-" + this.name;
          var mainContainer = domConstruct.toDom("<div style='display: flex; border: 2px solid #c9c9c9; position: relative;'>" + "<div style='position: relative; padding-left: 8px; padding-right: 6px; align-content: center;'>" + "<div style='position: relative; display: flex; align-items: center;'>" + "<select id='" + countrySelectId + "' " + "onchange='MC.updateSelectedFlag(this, " + this.europeanSmsExpansionEnabled + ")' " + "style='font-size: 16px; position: absolute; appearance: none; " + "background: transparent; border: none; padding-right: 20px; " + "opacity: 0; width: 100%; height: 100%; cursor: pointer; z-index: 3;'>" + this._buildCountryOptions() + "</select>" + "<div style='display: flex; align-items: center;" + "background: white; pointer-events: none; gap: 2px;'>" + "<span id='flag-" + this.name + "' style='font-size: 20px;'> " + this._getFlagEmoji(this._getDefaultCountryCode()) + "</span>" + "<svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' " + "viewBox='0 0 17 16' fill='none'>" + "<path d='M8.98616 10.6786C8.89846 10.6786 8.81162 10.6612 8.73063 10.6276C8.64964 10.594 8.57607 10.5447 8.51416 10.4826L4.51949 6.47659C4.45755 6.4146 4.40843 6.34103 4.37492 6.26006C4.34142 6.17909 4.32419 6.09231 4.32422 6.00468C4.32425 5.91706 4.34154 5.83029 4.3751 5.74935C4.40866 5.6684 4.45784 5.59486 4.51983 5.53292C4.58181 5.47098 4.65539 5.42185 4.73636 5.38835C4.81732 5.35484 4.9041 5.33762 4.99173 5.33765C5.07936 5.33768 5.16612 5.35497 5.24706 5.38853C5.32801 5.42209 5.40155 5.47127 5.46349 5.53325L8.98749 9.06659L12.5208 5.54325C12.646 5.41834 12.8157 5.34826 12.9925 5.34845C13.1694 5.34864 13.3389 5.41907 13.4638 5.54425C13.5887 5.66944 13.6588 5.83911 13.6586 6.01596C13.6584 6.19281 13.588 6.36234 13.4628 6.48725L9.45682 10.4839C9.33188 10.6085 9.16263 10.6785 8.98616 10.6786Z' fill='#21262A'/>" + "</svg>" + "</div>" + "</div>" + "</div>" + "<input type='text' style='border: none !important; flex: 1;' " + "name='" + this.name + "' " + "id='" + this.name + "' " + "size='20' " + "placeholder='" + this._getDefaultPlaceholder() + "' " + "value='" + this._getDefaultValue() + "'>" + "</div>");
          domConstruct.place(mainContainer, this.smsInputWrapper, "replace");
          this.smsInputWrapper = mainContainer;
          this.smsPhoneInput = mainContainer.querySelector('input[type="text"]');
          domStyle.set(this.smsInputWrapper, "position", "relative");
          domStyle.set(this.smsInputWrapper, "height", "40px");
          if (this.formsMultiCountryFastFollowsEnabled) {
            domStyle.set(this.smsInputWrapper, "margin-bottom", "5px");
          }
          domStyle.set(this.smsPhoneInput, "border", "none");
          domStyle.set(this.smsPhoneInput, "flex", "1");
          domStyle.set(this.smsPhoneInput, "z-index", "15");
          domStyle.set(this.smsPhoneInput, "position", "relative");
          if (!this.landingPagesInputStylesFixEnabled) {
            domStyle.set(this.smsPhoneInput, "background", "transparent");
          }
          domStyle.set(this.smsPhoneInput, "height", "100%");
          // Get default calling code for readonly prefix
          var defaultProgramData = this._getDefaultSmsProgramData();
          var defaultCallingCode = defaultProgramData ? defaultProgramData.countryCallingCode : "";

          // Set initial value with country code prefix
          if (defaultCallingCode) {
            this.smsPhoneInput.value = defaultCallingCode + " ";
          }

          // Store prefix length for readonly protection
          var prefixLength = (defaultCallingCode + " ").length;
          this.smsPhoneInput.setAttribute("data-prefix-length", prefixLength);
          this.smsPhoneInput.setAttribute("data-current-prefix", defaultCallingCode + " ");

          // Add event listeners to protect the readonly country code prefix
          this.smsPhoneInput.addEventListener("keydown", function (e) {
            var input = e.target;
            var prefixLen = parseInt(input.getAttribute("data-prefix-length"), 10) || 0;
            var selStart = input.selectionStart;
            var selEnd = input.selectionEnd;

            // Prevent backspace from deleting prefix
            if (e.key === "Backspace" && selStart <= prefixLen && selStart === selEnd) {
              e.preventDefault();
            }
            // Prevent delete from deleting prefix
            if (e.key === "Delete" && selStart < prefixLen) {
              e.preventDefault();
            }
            // Prevent arrow left from going into prefix
            if (e.key === "ArrowLeft" && selStart <= prefixLen && selStart === selEnd) {
              e.preventDefault();
            }
          });

          // Prevent selecting/editing within the prefix
          this.smsPhoneInput.addEventListener("click", function (e) {
            var input = e.target;
            var prefixLen = parseInt(input.getAttribute("data-prefix-length"), 10) || 0;
            if (input.selectionStart < prefixLen) {
              input.setSelectionRange(prefixLen, prefixLen);
            }
          });

          // Handle paste and input to ensure prefix is preserved
          this.smsPhoneInput.addEventListener("input", function (e) {
            var input = e.target;
            var currentPrefix = input.getAttribute("data-current-prefix") || "";

            // If prefix was corrupted, restore it
            if (!input.value.startsWith(currentPrefix)) {
              var phoneNumber = input.value.replace(/^\+\d+\s*/, "");
              input.value = currentPrefix + phoneNumber;
              input.setSelectionRange(input.value.length, input.value.length);
            }
          });
          if (this.multiCountryEnabled && this.smsProgramData !== "") {
            if (!window.MC) {
              window.MC = {};
            }
            window.MC.smsProgramData = this.smsProgramData;
            window.MC.required = this.required;
            window.MC.formsMultiCountryFastFollowsEnabled = this.formsMultiCountryFastFollowsEnabled;
            window.MC.legaleseVersionCaptureAndSaveEnabled = this.legaleseVersionCaptureAndSaveEnabled;
            window.MC.smsNotRequiredRemoveCountryCodeEnabled = this.smsNotRequiredRemoveCountryCodeEnabled;
          }
          var defaultProgramDataMulti = this._getDefaultSmsProgramData();
          if (this.required) {
            legalNode = domConstruct.toDom("<div id='sms-legal-text-required'>" + (defaultProgramDataMulti && defaultProgramDataMulti.requiredTemplate ? defaultProgramDataMulti.requiredTemplate : legalRequiredFallback) + "</div>");
            domConstruct.place(this._builAckNode(), this.smsLegal, "before");
            domStyle.set(this.smsLegal, "text-align", "left");
            domStyle.set(this.smsLegal, "align-items", "start");
            if (this.formsMultiCountryFastFollowsEnabled) {
              domStyle.set(this.smsLegal, "margin-bottom", "20px");
            }
          } else {
            legalNode = domConstruct.toDom("<div id='sms-legal-text-optional'>" + (defaultProgramDataMulti && defaultProgramDataMulti.optionalTemplate ? defaultProgramDataMulti.optionalTemplate : legalOptionalFallback) + "</div>");
            domStyle.set(this.smsLegal, "margin-bottom", "20px");
          }
          domConstruct.place(legalNode, this.smsLegal);

          // Add the country code span above the legal text
          var spanElement = domConstruct.toDom("<div style='display: flex; font-size: 12px; padding-top: 8px; padding-bottom: 8px; align-items: start;' id='help-text'>" + "" + this._getDefaultHelpText() + "" + "</span> " + "</span>" + "</div>");

          // Hide the help text if multi-country fast follows is enabled
          if (!this.formsMultiCountryFastFollowsEnabled) {
            // Add the span after the input container but before the legal text
            domConstruct.place(spanElement, this.smsInputWrapper, "after");
          }
        } else {
          // Single country: also prepend country code prefix
          var singleCountryCallingCode = "";
          if (this.smsProgramData && this.smsProgramData[0] && this.smsProgramData[0].countryCallingCode) {
            singleCountryCallingCode = this.smsProgramData[0].countryCallingCode;
          }

          // Ensure smsPhoneInput is available (from template attach point)
          var smsInput = this.smsPhoneInput;
          if (!smsInput && this.smsInputWrapper) {
            smsInput = query("input[type='text']", this.smsInputWrapper)[0];
          }

          // Set initial value with prefix
          if (singleCountryCallingCode && smsInput) {
            smsInput.value = singleCountryCallingCode + " ";
          }

          // Store prefix length for readonly protection
          var singleCountryPrefixLength = (singleCountryCallingCode + " ").length;
          if (singleCountryCallingCode && smsInput) {
            smsInput.setAttribute("data-prefix-length", singleCountryPrefixLength);
            smsInput.setAttribute("data-current-prefix", singleCountryCallingCode + " ");

            // Add event listeners to protect the readonly country code prefix
            smsInput.addEventListener("keydown", function (e) {
              var input = e.target;
              var prefixLen = parseInt(input.getAttribute("data-prefix-length"), 10) || 0;
              var selStart = input.selectionStart;
              var selEnd = input.selectionEnd;

              // Prevent backspace from deleting prefix
              if (e.key === "Backspace" && selStart <= prefixLen && selStart === selEnd) {
                e.preventDefault();
              }
              // Prevent delete from deleting prefix
              if (e.key === "Delete" && selStart < prefixLen) {
                e.preventDefault();
              }
              // Prevent arrow left from going into prefix
              if (e.key === "ArrowLeft" && selStart <= prefixLen && selStart === selEnd) {
                e.preventDefault();
              }
            });

            // Prevent selecting/editing within the prefix
            smsInput.addEventListener("click", function (e) {
              var input = e.target;
              var prefixLen = parseInt(input.getAttribute("data-prefix-length"), 10) || 0;
              if (input.selectionStart < prefixLen) {
                input.setSelectionRange(prefixLen, prefixLen);
              }
            });

            // Handle paste and input to ensure prefix is preserved
            smsInput.addEventListener("input", function (e) {
              var input = e.target;
              var prefixLen = parseInt(input.getAttribute("data-prefix-length"), 10) || 0;
              var currentPrefix = input.getAttribute("data-current-prefix") || "";

              // If prefix was corrupted, restore it
              if (!input.value.startsWith(currentPrefix)) {
                var phoneNumber = input.value.replace(/^\+\d+\s*/, "");
                input.value = currentPrefix + phoneNumber;
                input.setSelectionRange(input.value.length, input.value.length);
              }
            });

            // Update the attach point reference
            this.smsPhoneInput = smsInput;
          }

          // Ensure smsPhoneInput is available even if prefix logic didn't run
          if (!this.smsPhoneInput && this.smsInputWrapper) {
            this.smsPhoneInput = query("input[type='text']", this.smsInputWrapper)[0];
          }
          if (this.smsProgramData && this.smsProgramData[0]) {
            smsPrefix = domConstruct.toDom("<span " + 'data-dojo-attach-point="smsPrefix" ' + "id={prefixTextId} " + "className={stylesheet.inputPrefix} " + 'style="display:flex;position:absolute;padding-left:16px;padding-right:4px;">' + "<img " + 'src="' + this.smsProgramData[0].imgSrc + '" ' + 'alt="Country Code" width="28" height="28">' + "</img>" + "</span>");
            domConstruct.place(smsPrefix, this.smsInputWrapper, 0);
            domStyle.set(this.smsInputWrapper, "display", "flex");
            domStyle.set(this.smsInputWrapper, "margin-bottom", "5px");
            domStyle.set(this.smsInputWrapper, "align-items", "center");
            if (this.smsPhoneInput) {
              domStyle.set(this.smsPhoneInput, "margin", "unset");
              domStyle.set(this.smsPhoneInput, "padding-left", "48px");
            }
          }
          if (this.required) {
            legalNode = domConstruct.toDom("<div>" + (this.smsProgramData && this.smsProgramData[0] && this.smsProgramData[0].requiredTemplate ? this.smsProgramData[0].requiredTemplate : legalRequiredFallback) + "</div>");
            domConstruct.place(this._builAckNode(), this.smsLegal, "before");
          } else {
            legalNode = domConstruct.toDom("<div>" + (this.smsProgramData && this.smsProgramData[0] && this.smsProgramData[0].optionalTemplate ? this.smsProgramData[0].optionalTemplate : legalOptionalFallback) + "</div>");
            var optionalTag = "<span class=\"field-help\" style=\"width: auto; font-weight: lighter;\">" + globalConfig.optionLabel + "</span>";
            domConstruct.place(optionalTag, this.smsLabel, "last");
            domStyle.set(this.smsLegal, "margin-bottom", "20px");
          }
          domConstruct.place(legalNode, this.smsLegal);
        }
      }
      this.inherited(arguments);
    },
    _getDefaultPlaceholder: function () {
      var defaultProgramDataMulti = this._getDefaultSmsProgramData();
      var defaultPlaceholder = "";
      var mockPlaceholders;
      if (this.europeanSmsExpansionEnabled) {
        mockPlaceholders = [{
          countryCode: "US",
          placeholder: "+1 000 000 0000",
          helpText: "Include the US country code +1 before the phone number"
        }, {
          countryCode: "GB",
          placeholder: "+44 0000 000000",
          helpText: "Include the GB country code +44 before the phone number"
        }, {
          countryCode: "CA",
          placeholder: "+1 000 000 0000",
          helpText: "Include the CA country code +1 before the phone number"
        }, {
          countryCode: "AU",
          placeholder: "+61 000 000 000",
          helpText: "Include the AU country code +61 before the phone number"
        }, {
          countryCode: "DE",
          placeholder: "+49 000 0000000",
          helpText: "Fügen Sie vor der Telefonnummer die DE-Ländervorwahl +49 ein"
        }, {
          countryCode: "FR",
          placeholder: "+33 0 00 00 00 00",
          helpText: "Incluez le code pays FR +33 avant le numéro de téléphone"
        }, {
          countryCode: "ES",
          placeholder: "+34 000 000 000",
          helpText: "Incluya el código de país ES +34 antes del número de teléfono"
        }, {
          countryCode: "NL",
          placeholder: "+31 0 00000000",
          helpText: "Voeg de NL-landcode +31 toe vóór het telefoonnummer"
        }, {
          countryCode: "BE",
          placeholder: "+32 000 00 00 00",
          helpText: "Incluez le code pays BE +32 avant le numéro de téléphone"
        }, {
          countryCode: "CH",
          placeholder: "+41 00 000 00 00",
          helpText: "Fügen Sie vor der Telefonnummer die CH-Ländervorwahl +41 ein"
        }, {
          countryCode: "AT",
          placeholder: "+43 000 000 0000",
          helpText: "Fügen Sie vor der Telefonnummer die AT-Ländervorwahl +43 ein"
        }, {
          countryCode: "IE",
          placeholder: "+353 00 000 0000",
          helpText: "Include the IE country code +353 before the phone number"
        }, {
          countryCode: "IT",
          placeholder: "+39 000 000 0000",
          helpText: "Includere il prefisso internazionale IT +39 prima del numero di telefono"
        },
        // New European SMS Expansion countries
        {
          countryCode: "NO",
          placeholder: "+47 000 00 000",
          helpText: "Inkluder NO landskode +47 før telefonnummeret"
        }, {
          countryCode: "SE",
          placeholder: "+46 00 000 00 00",
          helpText: "Inkludera SE landskod +46 före telefonnumret"
        }, {
          countryCode: "DK",
          placeholder: "+45 00 00 00 00",
          helpText: "Inkluder DK landekode +45 før telefonnummeret"
        }, {
          countryCode: "FI",
          placeholder: "+358 00 000 0000",
          helpText: "Sisällytä FI-maakoodi +358 ennen puhelinnumeroa"
        }, {
          countryCode: "EE",
          placeholder: "+372 0000 0000",
          helpText: "Lisage EE riigikood +372 telefoninumbri ette"
        }, {
          countryCode: "PL",
          placeholder: "+48 000 000 000",
          helpText: "Podaj numer kierunkowy PL +48 przed numerem telefonu"
        }, {
          countryCode: "SK",
          placeholder: "+421 000 000 000",
          helpText: "Pred telefónne číslo uveďte kód krajiny SK +421"
        }, {
          countryCode: "LV",
          placeholder: "+371 0000 0000",
          helpText: "Iekļaujiet LV valsts kodu +371 pirms tālruņa numura"
        }, {
          countryCode: "LT",
          placeholder: "+370 0000 0000",
          helpText: "Įtraukite LT šalies kodą +370 prieš telefono numerį"
        }, {
          countryCode: "GR",
          placeholder: "+30 000 000 0000",
          helpText: "Συμπεριλάβετε τον κωδικό χώρας GR +30 πριν από τον αριθμό τηλεφώνου"
        }, {
          countryCode: "PT",
          placeholder: "+351 000 000 000",
          helpText: "Inclua o código de país PT +351 antes do número de telefone"
        }, {
          countryCode: "HR",
          placeholder: "+385 00 000 0000",
          helpText: "Uključite HR pozivni broj države +385 prije telefonskog broja"
        }, {
          countryCode: "SI",
          placeholder: "+386 00 000 000",
          helpText: "Vključite SI kodo države +386 pred telefonsko številko"
        }, {
          countryCode: "IS",
          placeholder: "+354 000 0000",
          helpText: "Láttu IS landsnúmer +354 fylgja á undan símanúmerinu"
        }, {
          countryCode: "LU",
          placeholder: "+352 000 000 000",
          helpText: "Incluez le code pays LU +352 avant le numéro de téléphone"
        }, {
          countryCode: "MC",
          placeholder: "+377 00 00 00 00",
          helpText: "Incluez le code pays MC +377 avant le numéro de téléphone"
        }, {
          countryCode: "AD",
          placeholder: "+376 000 000",
          helpText: "Incloeu el codi de país AD +376 abans del número de telèfon"
        }, {
          countryCode: "JE",
          placeholder: "+44 0000 000000",
          helpText: "Include the JE country code +44 before the phone number"
        }, {
          countryCode: "IM",
          placeholder: "+44 0000 000000",
          helpText: "Include the IM country code +44 before the phone number"
        }, {
          countryCode: "GG",
          placeholder: "+44 0000 000000",
          helpText: "Include the GG country code +44 before the phone number"
        }, {
          countryCode: "AL",
          placeholder: "+355 00 000 0000",
          helpText: "Përfshini kodin e vendit AL +355 para numrit të telefonit"
        }, {
          countryCode: "SM",
          placeholder: "+378 0000 000000",
          helpText: "Includere il prefisso internazionale SM +378 prima del numero di telefono"
        }, {
          countryCode: "FO",
          placeholder: "+298 000000",
          helpText: "Inkluder FO landekode +298 før telefonnummeret"
        }, {
          countryCode: "MT",
          placeholder: "+356 0000 0000",
          helpText: "Include the MT country code +356 before the phone number"
        }, {
          countryCode: "LI",
          placeholder: "+423 000 0000",
          helpText: "Fügen Sie vor der Telefonnummer die LI-Ländervorwahl +423 ein"
        }, {
          countryCode: "GI",
          placeholder: "+350 000 00000",
          helpText: "Include the GI country code +350 before the phone number"
        }, {
          countryCode: "MD",
          placeholder: "+373 00 000 000",
          helpText: "Includeți codul de țară MD +373 înaintea numărului de telefon"
        }, {
          countryCode: "HU",
          placeholder: "+36 00 000 0000",
          helpText: "A telefonszám előtt adja meg a HU országkódot +36"
        }, {
          countryCode: "NZ",
          placeholder: "+64 00 000 0000",
          helpText: "Include the NZ country code +64 before the phone number"
        }, {
          countryCode: "ME",
          placeholder: "+382 00 000 000",
          helpText: "Uključite ME pozivni broj države +382 prije telefonskog broja"
        }];
      } else {
        mockPlaceholders = [{
          countryCode: "US",
          placeholder: "+1 000 000 0000",
          helpText: "Include the US country code +1 before the phone number"
        }, {
          countryCode: "GB",
          placeholder: "+44 0000 000000",
          helpText: "Include the GB country code +44 before the phone number"
        }, {
          countryCode: "CA",
          placeholder: "+1 000 000 0000",
          helpText: "Include the CA country code +1 before the phone number"
        }, {
          countryCode: "AU",
          placeholder: "+61 000 000 000",
          helpText: "Include the AU country code +61 before the phone number"
        }, {
          countryCode: "DE",
          placeholder: "+49 000 0000000",
          helpText: "Fügen Sie vor der Telefonnummer die DE-Ländervorwahl +49 ein"
        }, {
          countryCode: "FR",
          placeholder: "+33 0 00 00 00 00",
          helpText: "Incluez le code pays FR +33 avant le numéro de téléphone"
        }, {
          countryCode: "ES",
          placeholder: "+34 000 000 000",
          helpText: "Incluya el código de país ES +34 antes del número de teléfono"
        }, {
          countryCode: "NL",
          placeholder: "+31 0 00000000",
          helpText: "Voeg de NL-landcode +31 toe vóór het telefoonnummer"
        }, {
          countryCode: "BE",
          placeholder: "+32 000 00 00 00",
          helpText: "Incluez le code pays BE +32 avant le numéro de téléphone"
        }, {
          countryCode: "CH",
          placeholder: "+41 00 000 00 00",
          helpText: "Fügen Sie vor der Telefonnummer die CH-Ländervorwahl +41 ein"
        }, {
          countryCode: "AT",
          placeholder: "+43 000 000 0000",
          helpText: "Fügen Sie vor der Telefonnummer die AT-Ländervorwahl +43 ein"
        }, {
          countryCode: "IE",
          placeholder: "+353 00 000 0000",
          helpText: "Include the IE country code +353 before the phone number"
        }, {
          countryCode: "IT",
          placeholder: "+39 000 000 0000",
          helpText: "Includere il prefisso internazionale IT +39 prima del numero di telefono"
        }];
      }

      // find the placeholder for the default country from the mockPlaceholders
      if (defaultProgramDataMulti && defaultProgramDataMulti.countryCode) {
        var defaultFound = mockPlaceholders.find(function (item) {
          return item.countryCode === defaultProgramDataMulti.countryCode;
        });
        if (defaultFound) {
          defaultPlaceholder = defaultFound.placeholder;
        } else {
          defaultPlaceholder = mockPlaceholders[0].placeholder;
        }
      }
      return defaultPlaceholder;
    },
    _getDefaultValue: function () {
      // var smsNotRequiredRemoveCountryCodeEnabled = this.smsNotRequiredRemoveCountryCodeEnabled;
      // var isRequired = this.required;
      // var shouldAppendCountryCode = smsNotRequiredRemoveCountryCodeEnabled ? isRequired : true;

      // if (!this.formsMultiCountryFastFollowsEnabled || !shouldAppendCountryCode) {
      //     return "";
      // }

      //  var defaultProgramDataMulti = this._getDefaultSmsProgramData();
      //  var prefix = defaultProgramDataMulti ? defaultProgramDataMulti.countryCallingCode : "";
      // return prefix;
      // Always return the country code prefix with a trailing space for readonly prefix behavior
      var defaultProgramDataMulti = this._getDefaultSmsProgramData();
      var prefix = defaultProgramDataMulti ? defaultProgramDataMulti.countryCallingCode : "";
      return prefix ? prefix + " " : "";
    },
    _getDefaultHelpText: function () {
      var mockPlaceholders;
      if (this.europeanSmsExpansionEnabled) {
        mockPlaceholders = [{
          countryCode: "US",
          placeholder: "+1 000 000 0000",
          helpText: "Include the US country code +1 before the phone number"
        }, {
          countryCode: "GB",
          placeholder: "+44 0000 000000",
          helpText: "Include the GB country code +44 before the phone number"
        }, {
          countryCode: "CA",
          placeholder: "+1 000 000 0000",
          helpText: "Include the CA country code +1 before the phone number"
        }, {
          countryCode: "AU",
          placeholder: "+61 000 000 000",
          helpText: "Include the AU country code +61 before the phone number"
        }, {
          countryCode: "DE",
          placeholder: "+49 000 0000000",
          helpText: "Fügen Sie vor der Telefonnummer die DE-Ländervorwahl +49 ein"
        }, {
          countryCode: "FR",
          placeholder: "+33 0 00 00 00 00",
          helpText: "Incluez le code pays FR +33 avant le numéro de téléphone"
        }, {
          countryCode: "ES",
          placeholder: "+34 000 000 000",
          helpText: "Incluya el código de país ES +34 antes del número de teléfono"
        }, {
          countryCode: "NL",
          placeholder: "+31 0 00000000",
          helpText: "Voeg de NL-landcode +31 toe vóór het telefoonnummer"
        }, {
          countryCode: "BE",
          placeholder: "+32 000 00 00 00",
          helpText: "Incluez le code pays BE +32 avant le numéro de téléphone"
        }, {
          countryCode: "CH",
          placeholder: "+41 00 000 00 00",
          helpText: "Fügen Sie vor der Telefonnummer die CH-Ländervorwahl +41 ein"
        }, {
          countryCode: "AT",
          placeholder: "+43 000 000 0000",
          helpText: "Fügen Sie vor der Telefonnummer die AT-Ländervorwahl +43 ein"
        }, {
          countryCode: "IE",
          placeholder: "+353 00 000 0000",
          helpText: "Include the IE country code +353 before the phone number"
        }, {
          countryCode: "IT",
          placeholder: "+39 000 000 0000",
          helpText: "Includere il prefisso internazionale IT +39 prima del numero di telefono"
        },
        // New European SMS Expansion countries
        {
          countryCode: "NO",
          placeholder: "+47 000 00 000",
          helpText: "Inkluder NO landskode +47 før telefonnummeret"
        }, {
          countryCode: "SE",
          placeholder: "+46 00 000 00 00",
          helpText: "Inkludera SE landskod +46 före telefonnumret"
        }, {
          countryCode: "DK",
          placeholder: "+45 00 00 00 00",
          helpText: "Inkluder DK landekode +45 før telefonnummeret"
        }, {
          countryCode: "FI",
          placeholder: "+358 00 000 0000",
          helpText: "Sisällytä FI-maakoodi +358 ennen puhelinnumeroa"
        }, {
          countryCode: "EE",
          placeholder: "+372 0000 0000",
          helpText: "Lisage EE riigikood +372 telefoninumbri ette"
        }, {
          countryCode: "PL",
          placeholder: "+48 000 000 000",
          helpText: "Podaj numer kierunkowy PL +48 przed numerem telefonu"
        }, {
          countryCode: "SK",
          placeholder: "+421 000 000 000",
          helpText: "Pred telefónne číslo uveďte kód krajiny SK +421"
        }, {
          countryCode: "LV",
          placeholder: "+371 0000 0000",
          helpText: "Iekļaujiet LV valsts kodu +371 pirms tālruņa numura"
        }, {
          countryCode: "LT",
          placeholder: "+370 0000 0000",
          helpText: "Įtraukite LT šalies kodą +370 prieš telefono numerį"
        }, {
          countryCode: "GR",
          placeholder: "+30 000 000 0000",
          helpText: "Συμπεριλάβετε τον κωδικό χώρας GR +30 πριν από τον αριθμό τηλεφώνου"
        }, {
          countryCode: "PT",
          placeholder: "+351 000 000 000",
          helpText: "Inclua o código de país PT +351 antes do número de telefone"
        }, {
          countryCode: "HR",
          placeholder: "+385 00 000 0000",
          helpText: "Uključite HR pozivni broj države +385 prije telefonskog broja"
        }, {
          countryCode: "SI",
          placeholder: "+386 00 000 000",
          helpText: "Vključite SI kodo države +386 pred telefonsko številko"
        }, {
          countryCode: "IS",
          placeholder: "+354 000 0000",
          helpText: "Láttu IS landsnúmer +354 fylgja á undan símanúmerinu"
        }, {
          countryCode: "LU",
          placeholder: "+352 000 000 000",
          helpText: "Incluez le code pays LU +352 avant le numéro de téléphone"
        }, {
          countryCode: "MC",
          placeholder: "+377 00 00 00 00",
          helpText: "Incluez le code pays MC +377 avant le numéro de téléphone"
        }, {
          countryCode: "AD",
          placeholder: "+376 000 000",
          helpText: "Incloeu el codi de país AD +376 abans del número de telèfon"
        }, {
          countryCode: "JE",
          placeholder: "+44 0000 000000",
          helpText: "Include the JE country code +44 before the phone number"
        }, {
          countryCode: "IM",
          placeholder: "+44 0000 000000",
          helpText: "Include the IM country code +44 before the phone number"
        }, {
          countryCode: "GG",
          placeholder: "+44 0000 000000",
          helpText: "Include the GG country code +44 before the phone number"
        }, {
          countryCode: "AL",
          placeholder: "+355 00 000 0000",
          helpText: "Përfshini kodin e vendit AL +355 para numrit të telefonit"
        }, {
          countryCode: "SM",
          placeholder: "+378 0000 000000",
          helpText: "Includere il prefisso internazionale SM +378 prima del numero di telefono"
        }, {
          countryCode: "FO",
          placeholder: "+298 000000",
          helpText: "Inkluder FO landekode +298 før telefonnummeret"
        }, {
          countryCode: "MT",
          placeholder: "+356 0000 0000",
          helpText: "Include the MT country code +356 before the phone number"
        }, {
          countryCode: "LI",
          placeholder: "+423 000 0000",
          helpText: "Fügen Sie vor der Telefonnummer die LI-Ländervorwahl +423 ein"
        }, {
          countryCode: "GI",
          placeholder: "+350 000 00000",
          helpText: "Include the GI country code +350 before the phone number"
        }, {
          countryCode: "MD",
          placeholder: "+373 00 000 000",
          helpText: "Includeți codul de țară MD +373 înaintea numărului de telefon"
        }, {
          countryCode: "HU",
          placeholder: "+36 00 000 0000",
          helpText: "A telefonszám előtt adja meg a HU országkódot +36"
        }, {
          countryCode: "NZ",
          placeholder: "+64 00 000 0000",
          helpText: "Include the NZ country code +64 before the phone number"
        }, {
          countryCode: "ME",
          placeholder: "+382 00 000 000",
          helpText: "Uključite ME pozivni broj države +382 prije telefonskog broja"
        }];
      } else {
        mockPlaceholders = [{
          countryCode: "US",
          placeholder: "+1 000 000 0000",
          helpText: "Include the US country code +1 before the phone number"
        }, {
          countryCode: "GB",
          placeholder: "+44 0000 000000",
          helpText: "Include the GB country code +44 before the phone number"
        }, {
          countryCode: "CA",
          placeholder: "+1 000 000 0000",
          helpText: "Include the CA country code +1 before the phone number"
        }, {
          countryCode: "AU",
          placeholder: "+61 000 000 000",
          helpText: "Include the AU country code +61 before the phone number"
        }, {
          countryCode: "DE",
          placeholder: "+49 000 0000000",
          helpText: "Fügen Sie vor der Telefonnummer die DE-Ländervorwahl +49 ein"
        }, {
          countryCode: "FR",
          placeholder: "+33 0 00 00 00 00",
          helpText: "Incluez le code pays FR +33 avant le numéro de téléphone"
        }, {
          countryCode: "ES",
          placeholder: "+34 000 000 000",
          helpText: "Incluya el código de país ES +34 antes del número de teléfono"
        }, {
          countryCode: "NL",
          placeholder: "+31 0 00000000",
          helpText: "Voeg de NL-landcode +31 toe vóór het telefoonnummer"
        }, {
          countryCode: "BE",
          placeholder: "+32 000 00 00 00",
          helpText: "Incluez le code pays BE +32 avant le numéro de téléphone"
        }, {
          countryCode: "CH",
          placeholder: "+41 00 000 00 00",
          helpText: "Fügen Sie vor der Telefonnummer die CH-Ländervorwahl +41 ein"
        }, {
          countryCode: "AT",
          placeholder: "+43 000 000 0000",
          helpText: "Fügen Sie vor der Telefonnummer die AT-Ländervorwahl +43 ein"
        }, {
          countryCode: "IE",
          placeholder: "+353 00 000 0000",
          helpText: "Include the IE country code +353 before the phone number"
        }, {
          countryCode: "IT",
          placeholder: "+39 000 000 0000",
          helpText: "Includere il prefisso internazionale IT +39 prima del numero di telefono"
        }];
      }
      var defaultHelpText = "";
      var defaultProgramDataMulti = this._getDefaultSmsProgramData();
      defaultHelpText = mockPlaceholders.find(function (item) {
        return item.countryCode === defaultProgramDataMulti.countryCode;
      });
      if (defaultHelpText) {
        defaultHelpText = defaultHelpText.helpText;
      }
      return defaultHelpText || mockPlaceholders[0].helpText;
    },
    _getCountryCode: function () {
      if (!this.smsProgramData || !Array.isArray(this.smsProgramData)) {
        return "";
      }
      for (var i = 0; i < this.smsProgramData.length; i++) {
        var country = this.smsProgramData[i];
        return country.countryCode;
      }
      return "";
    },
    _buildCountryOptions: function () {
      if (!this.smsProgramData || !Array.isArray(this.smsProgramData)) {
        return "";
      }
      var defaultCountryCode = this._getDefaultCountryCode();
      if (this.legaleseVersionCaptureAndSaveEnabled) {
        var seenCountries = {};
        return this.smsProgramData.filter(function (program) {
          if (seenCountries[program.countryCode]) {
            return false;
          }
          seenCountries[program.countryCode] = true;
          return true;
        }).map(function (country) {
          var countryName = this._getCountryName(country.countryCode);
          var selected = country.countryCode === defaultCountryCode ? " selected" : "";
          return "<option style='width: 650px; min-width: 650px;' value='" + country.countryCode + "' " + "data-flag='" + this._getFlagEmoji(country.countryCode) + "' " + "data-calling-code='" + country.countryCallingCode + "'" + selected + ">" + countryName + " " + country.countryCallingCode + "</option>";
        }, this).join("");
      }
      var options = "";
      for (var i = 0; i < this.smsProgramData.length; i++) {
        var country = this.smsProgramData[i];
        var countryName = this._getCountryName(country.countryCode);
        var selected = country.countryCode === defaultCountryCode ? " selected" : "";
        options += "<option style='width: 650px; min-width: 650px;' value='" + country.countryCode + "' " + "data-flag='" + this._getFlagEmoji(country.countryCode) + "' " + "data-calling-code='" + country.countryCallingCode + "'" + selected + ">" + countryName + " " + country.countryCallingCode + "</option>";
      }
      return options;
    },
    _getCountryName: function (countryCode) {
      if (this.countryNames && Array.isArray(this.countryNames)) {
        for (var i = 0; i < this.countryNames.length; i++) {
          if (this.countryNames[i].code === countryCode) {
            return this.countryNames[i].name;
          }
        }
      }
      return "";
    },
    _getBrowserLanguage: function () {
      var browserLanguage = "";
      if (typeof window !== "undefined" && window.navigator && window.navigator.language) {
        browserLanguage = window.navigator.language;
      }
      var languageCode = browserLanguage.split("-")[1] ? browserLanguage.split("-")[1].toUpperCase() : browserLanguage.split("-")[0].toUpperCase();
      return languageCode;
    },
    _getBrowserLanguageCode: function () {
      var navigatorLang = typeof window !== "undefined" && window.navigator && window.navigator.language ? window.navigator.language : "en";
      return navigatorLang.split("-")[0].toLowerCase();
    },
    _getSmsProgramForCountryAndLanguage: function (smsProgramData, countryCode, languageCode) {
      if (!smsProgramData || smsProgramData.length === 0 || !countryCode) {
        return null;
      }
      var entriesForCountry = smsProgramData.filter(function (p) {
        return p && p.countryCode === countryCode;
      });
      if (entriesForCountry.length === 0) {
        return null;
      }
      if (entriesForCountry.length === 1) {
        return entriesForCountry[0];
      }
      var langLower = languageCode.toLowerCase();
      var exactMatch = entriesForCountry.find(function (entry) {
        return (entry.language || "").toLowerCase() === langLower;
      });
      if (exactMatch) {
        return exactMatch;
      }
      var englishFallback = entriesForCountry.find(function (entry) {
        return (entry.language || "").toLowerCase() === "en";
      });
      return englishFallback || entriesForCountry[0];
    },
    _getDefaultSmsProgramData: function () {
      if (!this.smsProgramData || !Array.isArray(this.smsProgramData) || this.smsProgramData.length === 0) {
        return null;
      }
      if (this.legaleseVersionCaptureAndSaveEnabled) {
        var browserCountryCode = this._getBrowserLanguage();
        var browserLangCode = this._getBrowserLanguageCode();
        if (browserCountryCode) {
          var browserMatch = this._getSmsProgramForCountryAndLanguage(this.smsProgramData, browserCountryCode, browserLangCode);
          if (browserMatch) {
            return browserMatch;
          }
        }
        if (this.defaultCountryCode) {
          var defaultMatch = this._getSmsProgramForCountryAndLanguage(this.smsProgramData, this.defaultCountryCode, browserLangCode);
          if (defaultMatch) {
            return defaultMatch;
          }
        }
        return this.smsProgramData[0];
      }
      var defaultCountryProgramData;
      if (this.defaultCountryCode && this.smsProgramData) {
        defaultCountryProgramData = this.smsProgramData.find(function (program) {
          return program && program.countryCode === this.defaultCountryCode;
        }, this);
      }
      var browserLanguage = this._getBrowserLanguage();
      var browserCountrySmsProgramData;
      if (browserLanguage && this.smsProgramData) {
        browserCountrySmsProgramData = this.smsProgramData.find(function (program) {
          return program && program.countryCode === browserLanguage;
        });
      }
      if (browserCountrySmsProgramData) {
        return browserCountrySmsProgramData;
      }
      if (defaultCountryProgramData) {
        return defaultCountryProgramData;
      }
      return this.smsProgramData[0];
    },
    _getDefaultCountryCode: function () {
      if (!this.smsProgramData || !Array.isArray(this.smsProgramData)) {
        return "";
      }
      var defaultCountry = this._getDefaultSmsProgramData();
      return defaultCountry ? defaultCountry.countryCode : "";
    },
    _setDefaultCountry: function (countrySelectId, selectedFlagId) {
      var countrySelect = document.getElementById(countrySelectId);
      var selectedFlag = document.getElementById(selectedFlagId);
      if (countrySelect && selectedFlag) {
        var defaultSmsProgramData = this._getDefaultSmsProgramData();
        if (defaultSmsProgramData) {
          var defaultCountryCode = defaultSmsProgramData.countryCode;
          countrySelect.value = defaultCountryCode;
          selectedFlag.textContent = this._getFlagEmoji(defaultCountryCode);

          // Update legal text using the template from SMS program data
          var template = this.required ? defaultSmsProgramData.requiredTemplate : defaultSmsProgramData.optionalTemplate;
          if (template) {
            var smsLegalElementId = this.required ? "sms-legal-text-required" : "sms-legal-text-optional";
            var smsLegalElement = document.getElementById(smsLegalElementId);
            if (smsLegalElement) {
              smsLegalElement.innerHTML = template;
            }
          }
        }
      }
    }
  });
  var TextField = declare([_BaseField], {
    templateString: '<div class="field-wrapper">' + '<label for="mc-${name}">${label}</label>' + '<input type="text" name="${name}" value="" id="mc-${name}" />' + "</div>",
    validateAsType: "text"
  });
  var NumberField = declare([_BaseField], {
    templateString: "<div class='field-wrapper'>" + "<label for='mc-${name}'>${label}</label>" + "<input type='text' name='${name}' value='' id='mc-${name}' />" + "</div>",
    validateAsType: "number"
  });
  var AddressField = declare([_BaseField], {
    templateString: "<div class='field-wrapper address'>" + "<div>" + "<label for='mc-${name}-addr1'>${label}</label>" + "<input class='address1' type='text' name='${name}[addr1]' value='' id='mc-${name}-addr1' data-dojo-attach-point='address1Node' />" + "</div>" + "<div>" + "<label for='mc-${name}-addr2'>${addr2}</label>" + "<input class='address2' type='text' name='${name}[addr2]' value='' id='mc-${name}-addr2' />" + "</div>" + "<div>" + "<label for='mc-${name}-city'>${city}</label>" + "<input class='city' type='text' name='${name}[city]' value='' id='mc-${name}-city' data-dojo-attach-point='cityNode' />" + "</div>" + "<div>" + "<label for='mc-${name}-state'>${state}</label>" + "<input class='state' type='text' name='${name}[state]' value='' id='mc-${name}-state' data-dojo-attach-point='stateNode' />" + "</div>" + "<div>" + "<label for='mc-${name}-zip'>${zip}</label>" + "<input class='zip' type='text' name='${name}[zip]' value='' id='mc-${name}-zip' data-dojo-attach-point='zipNode' />" + "</div>" + "<div>" + "<label for='mc-${name}-country'>${country}</label>" + "<select class='country' name='${name}[country]' id='mc-${name}-country' data-dojo-attach-point='countrySelectNode'>" + "<option value='' selected></option>" + "<option value='164'>USA</option>" + "</select>" + "</div>" + "</div>",
    validateAsType: "address",
    postCreate: function () {
      var countries = [{
        "id": "286",
        "name": "Aaland Islands"
      }, {
        "id": "274",
        "name": "Afghanistan"
      }, {
        "id": "2",
        "name": "Albania"
      }, {
        "id": "3",
        "name": "Algeria"
      }, {
        "id": "178",
        "name": "American Samoa"
      }, {
        "id": "4",
        "name": "Andorra"
      }, {
        "id": "5",
        "name": "Angola"
      }, {
        "id": "176",
        "name": "Anguilla"
      }, {
        "id": "175",
        "name": "Antigua And Barbuda"
      }, {
        "id": "6",
        "name": "Argentina"
      }, {
        "id": "7",
        "name": "Armenia"
      }, {
        "id": "179",
        "name": "Aruba"
      }, {
        "id": "8",
        "name": "Australia"
      }, {
        "id": "9",
        "name": "Austria"
      }, {
        "id": "10",
        "name": "Azerbaijan"
      }, {
        "id": "11",
        "name": "Bahamas"
      }, {
        "id": "12",
        "name": "Bahrain"
      }, {
        "id": "13",
        "name": "Bangladesh"
      }, {
        "id": "14",
        "name": "Barbados"
      }, {
        "id": "15",
        "name": "Belarus"
      }, {
        "id": "16",
        "name": "Belgium"
      }, {
        "id": "17",
        "name": "Belize"
      }, {
        "id": "18",
        "name": "Benin"
      }, {
        "id": "19",
        "name": "Bermuda"
      }, {
        "id": "20",
        "name": "Bhutan"
      }, {
        "id": "21",
        "name": "Bolivia"
      }, {
        "id": "22",
        "name": "Bosnia and Herzegovina"
      }, {
        "id": "23",
        "name": "Botswana"
      }, {
        "id": "181",
        "name": "Bouvet Island"
      }, {
        "id": "24",
        "name": "Brazil"
      }, {
        "id": "180",
        "name": "Brunei Darussalam"
      }, {
        "id": "25",
        "name": "Bulgaria"
      }, {
        "id": "26",
        "name": "Burkina Faso"
      }, {
        "id": "27",
        "name": "Burundi"
      }, {
        "id": "28",
        "name": "Cambodia"
      }, {
        "id": "29",
        "name": "Cameroon"
      }, {
        "id": "30",
        "name": "Canada"
      }, {
        "id": "31",
        "name": "Cape Verde"
      }, {
        "id": "32",
        "name": "Cayman Islands"
      }, {
        "id": "33",
        "name": "Central African Republic"
      }, {
        "id": "34",
        "name": "Chad"
      }, {
        "id": "35",
        "name": "Chile"
      }, {
        "id": "36",
        "name": "China"
      }, {
        "id": "185",
        "name": "Christmas Island"
      }, {
        "id": "37",
        "name": "Colombia"
      }, {
        "id": "204",
        "name": "Comoros"
      }, {
        "id": "38",
        "name": "Congo"
      }, {
        "id": "183",
        "name": "Cook Islands"
      }, {
        "id": "268",
        "name": "Costa Rica"
      }, {
        "id": "275",
        "name": "Cote D'Ivoire"
      }, {
        "id": "40",
        "name": "Croatia"
      }, {
        "id": "276",
        "name": "Cuba"
      }, {
        "id": "298",
        "name": "Curacao"
      }, {
        "id": "41",
        "name": "Cyprus"
      }, {
        "id": "42",
        "name": "Czech Republic"
      }, {
        "id": "43",
        "name": "Denmark"
      }, {
        "id": "44",
        "name": "Djibouti"
      }, {
        "id": "289",
        "name": "Dominica"
      }, {
        "id": "187",
        "name": "Dominican Republic"
      }, {
        "id": "233",
        "name": "East Timor"
      }, {
        "id": "45",
        "name": "Ecuador"
      }, {
        "id": "46",
        "name": "Egypt"
      }, {
        "id": "47",
        "name": "El Salvador"
      }, {
        "id": "48",
        "name": "Equatorial Guinea"
      }, {
        "id": "49",
        "name": "Eritrea"
      }, {
        "id": "50",
        "name": "Estonia"
      }, {
        "id": "51",
        "name": "Ethiopia"
      }, {
        "id": "189",
        "name": "Falkland Islands"
      }, {
        "id": "191",
        "name": "Faroe Islands"
      }, {
        "id": "52",
        "name": "Fiji"
      }, {
        "id": "53",
        "name": "Finland"
      }, {
        "id": "54",
        "name": "France"
      }, {
        "id": "193",
        "name": "French Guiana"
      }, {
        "id": "277",
        "name": "French Polynesia"
      }, {
        "id": "56",
        "name": "Gabon"
      }, {
        "id": "57",
        "name": "Gambia"
      }, {
        "id": "58",
        "name": "Georgia"
      }, {
        "id": "59",
        "name": "Germany"
      }, {
        "id": "60",
        "name": "Ghana"
      }, {
        "id": "194",
        "name": "Gibraltar"
      }, {
        "id": "61",
        "name": "Greece"
      }, {
        "id": "195",
        "name": "Greenland"
      }, {
        "id": "192",
        "name": "Grenada"
      }, {
        "id": "196",
        "name": "Guadeloupe"
      }, {
        "id": "62",
        "name": "Guam"
      }, {
        "id": "198",
        "name": "Guatemala"
      }, {
        "id": "270",
        "name": "Guernsey"
      }, {
        "id": "63",
        "name": "Guinea"
      }, {
        "id": "65",
        "name": "Guyana"
      }, {
        "id": "200",
        "name": "Haiti"
      }, {
        "id": "66",
        "name": "Honduras"
      }, {
        "id": "67",
        "name": "Hong Kong"
      }, {
        "id": "68",
        "name": "Hungary"
      }, {
        "id": "69",
        "name": "Iceland"
      }, {
        "id": "70",
        "name": "India"
      }, {
        "id": "71",
        "name": "Indonesia"
      }, {
        "id": "278",
        "name": "Iran"
      }, {
        "id": "279",
        "name": "Iraq"
      }, {
        "id": "74",
        "name": "Ireland"
      }, {
        "id": "75",
        "name": "Israel"
      }, {
        "id": "76",
        "name": "Italy"
      }, {
        "id": "202",
        "name": "Jamaica"
      }, {
        "id": "78",
        "name": "Japan"
      }, {
        "id": "288",
        "name": "Jersey (Channel Islands)"
      }, {
        "id": "79",
        "name": "Jordan"
      }, {
        "id": "80",
        "name": "Kazakhstan"
      }, {
        "id": "81",
        "name": "Kenya"
      }, {
        "id": "203",
        "name": "Kiribati"
      }, {
        "id": "82",
        "name": "Kuwait"
      }, {
        "id": "83",
        "name": "Kyrgyzstan"
      }, {
        "id": "84",
        "name": "Lao People's Democratic Republic"
      }, {
        "id": "85",
        "name": "Latvia"
      }, {
        "id": "86",
        "name": "Lebanon"
      }, {
        "id": "87",
        "name": "Lesotho"
      }, {
        "id": "88",
        "name": "Liberia"
      }, {
        "id": "281",
        "name": "Libya"
      }, {
        "id": "90",
        "name": "Liechtenstein"
      }, {
        "id": "91",
        "name": "Lithuania"
      }, {
        "id": "92",
        "name": "Luxembourg"
      }, {
        "id": "208",
        "name": "Macau"
      }, {
        "id": "93",
        "name": "Macedonia"
      }, {
        "id": "94",
        "name": "Madagascar"
      }, {
        "id": "95",
        "name": "Malawi"
      }, {
        "id": "96",
        "name": "Malaysia"
      }, {
        "id": "97",
        "name": "Maldives"
      }, {
        "id": "98",
        "name": "Mali"
      }, {
        "id": "99",
        "name": "Malta"
      }, {
        "id": "207",
        "name": "Marshall Islands"
      }, {
        "id": "210",
        "name": "Martinique"
      }, {
        "id": "100",
        "name": "Mauritania"
      }, {
        "id": "212",
        "name": "Mauritius"
      }, {
        "id": "241",
        "name": "Mayotte"
      }, {
        "id": "101",
        "name": "Mexico"
      }, {
        "id": "102",
        "name": "Moldova, Republic of"
      }, {
        "id": "103",
        "name": "Monaco"
      }, {
        "id": "104",
        "name": "Mongolia"
      }, {
        "id": "290",
        "name": "Montenegro"
      }, {
        "id": "294",
        "name": "Montserrat"
      }, {
        "id": "105",
        "name": "Morocco"
      }, {
        "id": "106",
        "name": "Mozambique"
      }, {
        "id": "242",
        "name": "Myanmar"
      }, {
        "id": "107",
        "name": "Namibia"
      }, {
        "id": "108",
        "name": "Nepal"
      }, {
        "id": "109",
        "name": "Netherlands"
      }, {
        "id": "110",
        "name": "Netherlands Antilles"
      }, {
        "id": "213",
        "name": "New Caledonia"
      }, {
        "id": "111",
        "name": "New Zealand"
      }, {
        "id": "112",
        "name": "Nicaragua"
      }, {
        "id": "113",
        "name": "Niger"
      }, {
        "id": "114",
        "name": "Nigeria"
      }, {
        "id": "217",
        "name": "Niue"
      }, {
        "id": "214",
        "name": "Norfolk Island"
      }, {
        "id": "272",
        "name": "North Korea"
      }, {
        "id": "116",
        "name": "Norway"
      }, {
        "id": "117",
        "name": "Oman"
      }, {
        "id": "118",
        "name": "Pakistan"
      }, {
        "id": "222",
        "name": "Palau"
      }, {
        "id": "282",
        "name": "Palestine"
      }, {
        "id": "119",
        "name": "Panama"
      }, {
        "id": "219",
        "name": "Papua New Guinea"
      }, {
        "id": "120",
        "name": "Paraguay"
      }, {
        "id": "121",
        "name": "Peru"
      }, {
        "id": "122",
        "name": "Philippines"
      }, {
        "id": "221",
        "name": "Pitcairn"
      }, {
        "id": "123",
        "name": "Poland"
      }, {
        "id": "124",
        "name": "Portugal"
      }, {
        "id": "126",
        "name": "Qatar"
      }, {
        "id": "315",
        "name": "Republic of Kosovo"
      }, {
        "id": "127",
        "name": "Reunion"
      }, {
        "id": "128",
        "name": "Romania"
      }, {
        "id": "129",
        "name": "Russia"
      }, {
        "id": "130",
        "name": "Rwanda"
      }, {
        "id": "205",
        "name": "Saint Kitts and Nevis"
      }, {
        "id": "206",
        "name": "Saint Lucia"
      }, {
        "id": "237",
        "name": "Saint Vincent and the Grenadines"
      }, {
        "id": "132",
        "name": "Samoa (Independent)"
      }, {
        "id": "227",
        "name": "San Marino"
      }, {
        "id": "133",
        "name": "Saudi Arabia"
      }, {
        "id": "134",
        "name": "Senegal"
      }, {
        "id": "266",
        "name": "Serbia"
      }, {
        "id": "135",
        "name": "Seychelles"
      }, {
        "id": "136",
        "name": "Sierra Leone"
      }, {
        "id": "137",
        "name": "Singapore"
      }, {
        "id": "302",
        "name": "Sint Maarten"
      }, {
        "id": "138",
        "name": "Slovakia"
      }, {
        "id": "139",
        "name": "Slovenia"
      }, {
        "id": "223",
        "name": "Solomon Islands"
      }, {
        "id": "140",
        "name": "Somalia"
      }, {
        "id": "141",
        "name": "South Africa"
      }, {
        "id": "257",
        "name": "South Georgia and the South Sandwich Islands"
      }, {
        "id": "142",
        "name": "South Korea"
      }, {
        "id": "311",
        "name": "South Sudan"
      }, {
        "id": "143",
        "name": "Spain"
      }, {
        "id": "144",
        "name": "Sri Lanka"
      }, {
        "id": "293",
        "name": "Sudan"
      }, {
        "id": "146",
        "name": "Suriname"
      }, {
        "id": "225",
        "name": "Svalbard and Jan Mayen Islands"
      }, {
        "id": "147",
        "name": "Swaziland"
      }, {
        "id": "148",
        "name": "Sweden"
      }, {
        "id": "149",
        "name": "Switzerland"
      }, {
        "id": "285",
        "name": "Syria"
      }, {
        "id": "152",
        "name": "Taiwan"
      }, {
        "id": "260",
        "name": "Tajikistan"
      }, {
        "id": "153",
        "name": "Tanzania"
      }, {
        "id": "154",
        "name": "Thailand"
      }, {
        "id": "155",
        "name": "Togo"
      }, {
        "id": "232",
        "name": "Tonga"
      }, {
        "id": "234",
        "name": "Trinidad and Tobago"
      }, {
        "id": "156",
        "name": "Tunisia"
      }, {
        "id": "157",
        "name": "Turkey"
      }, {
        "id": "287",
        "name": "Turks &amp; Caicos Islands"
      }, {
        "id": "159",
        "name": "Uganda"
      }, {
        "id": "161",
        "name": "Ukraine"
      }, {
        "id": "162",
        "name": "United Arab Emirates"
      }, {
        "id": "262",
        "name": "United Kingdom"
      }, {
        "id": "163",
        "name": "Uruguay"
      }, {
        "id": "165",
        "name": "Uzbekistan"
      }, {
        "id": "239",
        "name": "Vanuatu"
      }, {
        "id": "166",
        "name": "Vatican City State (Holy See)"
      }, {
        "id": "167",
        "name": "Venezuela"
      }, {
        "id": "168",
        "name": "Vietnam"
      }, {
        "id": "169",
        "name": "Virgin Islands (British)"
      }, {
        "id": "238",
        "name": "Virgin Islands (U.S.)"
      }, {
        "id": "188",
        "name": "Western Sahara"
      }, {
        "id": "170",
        "name": "Yemen"
      }, {
        "id": "173",
        "name": "Zambia"
      }, {
        "id": "174",
        "name": "Zimbabwe"
      }];
      array.forEach(countries, lang.hitch(this, function (country) {
        var el = "<option value='" + country.id + "'>" + country.name + "</option>";
        domConstruct.place(el, this.countrySelectNode, "last");
      }));
      this.inherited(arguments);
    }
  });
  var EmailField = declare([_BaseField], {
    templateString: "<div class='field-wrapper'>" + "<label for='mc-${name}'>${label}</label>" + "<input type='text' name='${name}' value='' id='mc-${name}' />" + "</div>",
    validateAsType: "email"
  });
  var BirthdayField = declare([_BaseField], {
    templateString: "<div class='field-wrapper birthday'>" + "<label for='mc-${name}-month'>${label}</label>" + "<div data-dojo-attach-point='inputsContainer'>" + "<input class='birthday-month' type='text' placeholder='MM' maxlength='2' name='${name}[month]' value='' id='mc-${name}-month' data-dojo-attach-point='monthNode' />" + "<input class='birthday-day' type='text' placeholder='DD' maxlength='2' name='${name}[day]' value='' id='mc-${name}-day' data-dojo-attach-point='dayNode' />" + "</div>" + "</div>",
    validateAsType: "birthday",
    validateAsGroup: true,
    postCreate: function () {
      this.inherited(arguments);
      if (this.dateformat === "DD/MM") {
        domConstruct.place(this.dayNode, this.inputsContainer, "first");
        domConstruct.place(this.monthNode, this.inputsContainer, "last");
      }
    }
  });
  var DateField = declare([_BaseField], {
    templateString: "<div class='field-wrapper date'>" + "<label for='mc-${name}-month'>${label}</label>" + "<div data-dojo-attach-point='inputsContainer'>" + "<input class='date-year' type='text' maxlength='4' placeholder='YYYY' name='${name}[year]' value='' id='mc-${name}-year' data-dojo-attach-point='yearNode' />" + "<input class='date-month' type='text' maxlength='2' placeholder='MM' name='${name}[month]' value='' id='mc-${name}-month' data-dojo-attach-point='monthNode' />" + "<input class='date-day' type='text' maxlength='2' placeholder='DD' name='${name}[day]' value='' id='mc-${name}-day' data-dojo-attach-point='dayNode' />" + "</div>" + "</div>",
    validateAsType: "date",
    validateAsGroup: true,
    postCreate: function () {
      this.inherited(arguments);
      if (this.dateformat === "MM/DD/YYYY") {
        domConstruct.place(this.monthNode, this.inputsContainer, "first");
        domConstruct.place(this.yearNode, this.inputsContainer, "last");
      } else if (this.dateformat === "DD/MM/YYYY") {
        domConstruct.place(this.dayNode, this.inputsContainer, "first");
        domConstruct.place(this.yearNode, this.inputsContainer, "last");
      }
    }
  });
  var PhoneField = declare([_BaseField], {
    templateString: "<div class='field-wrapper phone'>" + "<label for='mc-${name}-area'>${label}</label>" + "<div>" + "<input class='phone-area' type='text' maxlength='3' placeholder='###' name='${name}[area]' value='' id='mc-${name}-area' data-dojo-attach-point='phoneAreaNode' />" + "<input class='phone-detail1' type='text' maxlength='3' placeholder='###' name='${name}[detail1]' value='' id='mc-${name}-detail1' data-dojo-attach-point='phoneDetail1Node' />" + "<input class='phone-detail2' type='text' maxlength='4' placeholder='####' name='${name}[detail2]' value='' id='mc-${name}-detail2' data-dojo-attach-point='phoneDetail2Node' />" + "</div>" + "</div>",
    validateAsType: "phone",
    validateAsGroup: true
  });
  var HiddenField = declare([_BaseField], {
    templateString: "<div class='field-wrapper'>" + "<input type='hidden' name='${name}' value='' id='mc-${name}' />" + "</div>"
  });
  var UrlField = declare([_BaseField], {
    templateString: "<div class='field-wrapper'>" + "<label for='mc-${name}'>${label}</label>" + "<input type='text' placeholder='http://' name='${name}' value='' id='mc-${name}' />" + "</div>",
    validateAsType: "url"
  });
  var RadioCheckboxField = declare([_BaseField], {
    templateString: "<div class='field-wrapper radio-group'>" + "<label for='mc-${name}'>${label}</label>" + "<ul class='radioCheckboxContainer' data-dojo-attach-point='choicesContainer'></ul>" + "</div>",
    validateAsType: "radiocheckbox",
    postCreate: function () {
      array.forEach(this.choices, lang.hitch(this, function (choice, i) {
        // Create a unique id for each choice for use with label, (e.g., group[3]-3-0 or MMERGE17-0)
        var id = this.merge_id ? this.name + "-" + i : this.name + "-" + this.group_id + "-" + i;
        id = "mc-" + id;
        var name, extras;
        if (this.type === "checkbox") {
          // If it's a checkbox, make the input name an array with values as keys
          name = this.name + "[" + choice.value + "]";
          extras = "<div class='checkbox-bg'></div>";
        } else {
          name = this.name;
          // Put an empty div within the label to render active radio button state
          extras = "<div class='radio-fill'></div>";
        }
        var input = domConstruct.create("input", {
          id: id,
          type: this.type,
          value: choice.value,
          name: name
        });
        var label = domConstruct.create("label", {
          "for": id,
          "class": this.type
        });
        var labelContent = document.createTextNode(choice.label);
        var backgroundSpan = domConstruct.create("div", {
          "class": "hover-focus-background"
        });
        var flexSpacer = domConstruct.create("div", {
          "class": "flex-spacer"
        });
        var li = domConstruct.create("li");
        domConstruct.place(input, label);
        domConstruct.place(labelContent, label);
        if (extras) {
          domConstruct.place(extras, label);
        }
        domConstruct.place(backgroundSpan, label);
        domConstruct.place(label, li);
        domConstruct.place(flexSpacer, li);
        domConstruct.place(li, this.choicesContainer, "last");
      }));
      this.inherited(arguments);
    }
  });
  var GdprCheckboxField = declare([_BaseField], {
    templateString: "<li class=\"field-wrapper !margin-bottom--lv2\">" + "<label class=\"checkbox\" for=\"gdpr-${marketing_preference_id}\">" + "<input type=\"checkbox\" id=\"gdpr-${marketing_preference_id}\" name=\"${name}\" data-dojo-attach-point=\"choicesContainer\" />" + "<span>${label}</span>" + "</label>" + "</li>",
    validateAsType: "radiocheckbox"
  });
  var SelectField = declare([_BaseField], {
    templateString: "<div class='field-wrapper'>" + "<label for='mc-${name}'>${label}</label>" + "<select name='${name}' id='mc-${name}' data-dojo-attach-point='choicesContainer'></select>" + "</div>",
    validateAsType: "select",
    postCreate: function () {
      var emptyOptionNodes = []; // Keep track of empty nodes. We'll set one of them to selected, or create one if none exist.
      array.forEach(this.choices, lang.hitch(this, function (choice) {
        var option = domConstruct.toDom("<option value='" + choice.value + "'>" + choice.label + "</option>");
        if (this._empty(choice.label)) {
          emptyOptionNodes.push(option);
        }
        domConstruct.place(option, this.choicesContainer, "last");
      }));
      // If there's no empty option, create one. Otherwise add 'selected' attribute to first empty option node.
      if (emptyOptionNodes.length > 0) {
        domAttr.set(emptyOptionNodes[0], "selected", "selected");
      } else {
        domConstruct.place("<option value='' selected='selected'></option>", this.choicesContainer, "first");
      }
      this.inherited(arguments);
    }
  });
  var GdprBlock = declare([_WidgetBase, _TemplatedMixin], {
    templateString: "<div class=\"content__gdprBlock\">" + "<div class=\"content__gdpr\">" + "<label>${gdprLabel}</label>" + "<p>${gdprDescription}</p>" + "<div data-dojo-attach-point=\"errorMessageNode\" class=\"errorText\"></div>" + "<ul class=\"content__gdprFields radioCheckboxContainer\" data-dojo-attach-point=\"gdprFieldsContainer\"></ul>" + "<p data-dojo-attach-point=\"gdprLegalContainer\"></p>" + "</div>" + "<div class=\"content__gdprLegal\">" + "<a href=\"https://www.mailchimp.com/gdpr\" target=\"_blank\"><img src=\"${iconImgUrl}\" alt=\"GDPR\" /></a>" + "<p data-dojo-attach-point=\"gdprMcLegalContainer\"></p>" + "</div>" + "</div>",
    gdprLabel: "",
    gdprDescription: "",
    gdprLegal: "",
    gdprMCLegal: "",
    errorMessage: "",
    _setErrorMessageAttr: {
      node: "errorMessageNode",
      type: "innerText"
    },
    iconImgUrl: "https://eep.io/mc-cdn-images/icons/mailchimp-gdpr.svg",
    postCreate: function () {
      this.inherited(arguments);
      domConstruct.place(this.gdprMCLegal, this.gdprMcLegalContainer);
      domConstruct.place(this.gdprLegal, this.gdprLegalContainer);
    }
  });
  var CaptchaField = declare([_BaseField], {
    templateString: "<div class='field-wrapper' style='margin-bottom: 6px;'>" + "<div data-dojo-attach-point='captchaNode' class='g-recaptcha' data-size='invisible'></div>" + "</div>",
    validateAsType: null,
    postCreate: function () {
      // eslint-disable-next-line no-undef
      grecaptcha.render(this.captchaNode, {
        sitekey: this.recaptchaSitekey,
        callback: lang.hitch(this, "captchaCallback")
      });
      this.inherited(arguments);
    },
    captchaCallback: function () {
      this.setFieldAsValid();
      this.emit("success", {});
    }
  });
  return declare("SignupForm", [_WidgetBase, _TemplatedMixin, Evented, _CustomStyleRulesMixin], {
    templateString: '<div class="webContent">' + '<div class="flash-block" data-dojo-attach-point="formResponseMessages"></div>' + '<div class="webContent__content" data-dojo-attach-point="formContentContainer">' + '<form action="${subscribeUrl}" accept-charset="UTF-8" method="post" enctype="multipart/form-data" data-dojo-attach-point="formNode" novalidate>' + '<div class="content__formFields" data-dojo-attach-point="formFieldsContainer"></div>' + '<div class="content__button">' + '<input class="button" type="submit" value="${buttonLabel}" data-dojo-attach-point="submitButton"/>' + "</div>" + "</form>" + "</div>" + "</div>",
    trackSubmitUrl: "#",
    subscribeUrl: "#",
    appDomain: "",
    honeypotFieldName: "",
    honeytime: "",
    recaptchaSitekey: "",
    captchaEnabled: false,
    // Mirrors PHP aorg.age_gating_enabled flag; when true, submit via POST instead of GET.
    usePost: false,
    fields: [],
    buttonLabel: "Subscribe",
    config: {},
    translations: {},
    constructor: function () {
      this.formIsValid = false;
      this.fieldNodes = [];
    },
    postMixInProperties: function () {
      // Pull values from the config
      this.fields = this.config.fields;
      globalConfig = this.config;
      if (this.config.buttonLabel) {
        var decodedLabel = entities.decode(this.config.buttonLabel);
        this.buttonLabel = decodedLabel;
      }
      if (this.config.styles) {
        this.styles = this.config.styles;
      }
    },
    postCreate: function () {
      // Update the height when CSS is finished loading
      var files = [];
      translations = this.translations;
      files.push(this.loadCustomCss());
      if (this.captchaEnabled) {
        files.push(this.loadCaptchaJs());
      }
      var hasEmailField = this.fields.some(function (field) {
        return field.type === "email";
      });
      if (!hasEmailField) {
        this.config.gdprEnabled = false;
      }
      all(files).then(lang.hitch(this, function () {
        // GDPR
        if (this.config.gdprEnabled) {
          this.gdprContent = new GdprBlock({
            gdprLabel: this.config.gdprLabel,
            gdprDescription: this.config.gdprDescription,
            // dom.Construct.toDom for HTML of gdprMCLegal to properly render.
            // surround with <span> to ensure valid HTML fragment.
            gdprLegal: domConstruct.toDom("<span>" + this.config.gdprLegal + "</span>"),
            gdprMCLegal: domConstruct.toDom("<span>" + this.config.gdprMCLegal + "</span>")
          });
          this.gdprContent.placeAt(this.formFieldsContainer, "after");
        }
        this.addFields();
        this.addHoneypot();
        this.addHoneytime();
        if (this.captchaEnabled) {
          var captchaField = this.addCaptcha();
          captchaField.on("success", lang.hitch(this, function () {
            this.submitForm();
          }));
        }
      }));
      on(this.formNode, "submit", lang.hitch(this, function (evt) {
        // Prevent page to navigate away
        evt.stopPropagation();
        evt.preventDefault();
        if (!this.isPreview) {
          request.get(this.trackSubmitUrl);
        }
        var formErrorsNode = query(".flash-errors", this.formResponseMessages)[0];
        if (formErrorsNode) {
          domStyle.set(formErrorsNode, "display", "none");
        }
        this._validateForm();
        if (this.formIsValid) {
          if (this.captchaEnabled) {
            // eslint-disable-next-line no-undef
            grecaptcha.execute(); // successful captcha completion callback calls submitForm
          } else {
            this.submitForm();
          }
        } else {
          this.emit("resizeFrame", {});
        }
      }));
    },
    addFields: function () {
      if (this.fieldNodes.length) {
        array.forEach(this.fieldNodes, function (input) {
          input.destroy();
        });
        this.fieldNodes = [];
        domConstruct.empty(this.formFieldsContainer);
        if (this.gdprContent && this.config.gdprEnabled) {
          domConstruct.empty(this.gdprContent.gdprFieldsContainer);
        }
      }
      array.forEach(this.fields, lang.hitch(this, function (fieldData) {
        if (fieldData.marketing_preference_id && !this.config.gdprEnabled) {
          return;
        }
        if (fieldData.type === "address") {
          fieldData.addr2 = this.translations.ADDR2;
          fieldData.zip = this.translations.ADDRZIP;
          fieldData.city = this.translations.ADDRCITY;
          fieldData.state = this.translations.ADDRSTATE;
          fieldData.country = this.translations.ADDRCOUNTRY;
        }
        var field = this._createField(fieldData);
        if (field) {
          if (this.gdprContent && this.config.gdprEnabled && fieldData.marketing_preference_id) {
            field.placeAt(this.gdprContent.gdprFieldsContainer);
          } else {
            field.placeAt(this.formFieldsContainer);
          }
          field.startup();
        }
      }));
    },
    addHoneypot: function () {
      var trap = domConstruct.toDom('<div style="position:absolute;left:-5000px;" aria-hidden="true"><input type="text" name="' + this.honeypotFieldName + '" tabindex="-1" value=""></div>');
      domConstruct.place(trap, this.formFieldsContainer, "last");
    },
    addHoneytime: function () {
      if (!this.honeytime) {
        return;
      }
      var ht = domConstruct.toDom('<input type="hidden" name="ht" value="' + this.honeytime + '">');
      domConstruct.place(ht, this.formFieldsContainer, "last");
    },
    addCaptcha: function () {
      var field = this._createField({
        type: "captcha",
        "recaptchaSitekey": this.recaptchaSitekey
      });
      field.placeAt(this.formFieldsContainer);
      field.startup();
      return field;
    },
    _validateForm: function () {
      var formErrors = [];
      array.forEach(this.fieldNodes, function (field) {
        var e = field.validateField();
        if (e.length > 0) {
          formErrors.push(e);
        }
      });
      this.formIsValid = !(formErrors.length > 0);
    },
    submitForm: function () {
      // Clean SMS phone fields - remove prefix if user didn't enter anything
      this._cleanSmsPhoneFieldsBeforeSubmit();
      var customer_session_id_param = cookie("mc_customer_session_id") === undefined ? "" : "&customer_session_id=" + encodeURIComponent(cookie("mc_customer_session_id"));
      var formQuery = domForm.toQuery(this.formNode) + customer_session_id_param;
      var promise = this.usePost ? xhr.post(this.subscribeUrl, {
        handleAs: "json",
        data: formQuery,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": ""
        }
      }) : request.get(this.subscribeUrl, formQuery);
      promise.then(lang.hitch(this, function (response) {
        if (response.result === "error") {
          this._handleErrorResponse(response);
        } else {
          this._handleSuccessResponse(response);
        }
        this.emit("resizeFrame", {});
      }));
    },
    /**
     * Clean SMS phone fields before submission - remove prefix if user didn't enter anything
     * This prevents sending just the prefix (e.g., "+1 ") when the user hasn't entered a phone number
     */
    _cleanSmsPhoneFieldsBeforeSubmit: function () {
      // Find all SMS phone inputs in the form
      var smsInputs = query("input[name='SMSPHONE'], input[id*='SMSPHONE'], input[id*='smsphone'], input[name*='SMSPHONE']", this.formNode);
      array.forEach(smsInputs, function (input) {
        if (!input) {
          return;
        }
        var currentValue = input.value || "";
        var prefix = input.getAttribute("data-current-prefix") || "";
        // If we have a prefix, check if the value is just the prefix (or prefix + whitespace)
        if (prefix) {
          var trimmedValue = currentValue.trim();
          var trimmedPrefix = prefix.trim();
          // If the value is just the prefix (with or without trailing whitespace), clear it
          if (trimmedValue === trimmedPrefix || trimmedValue === prefix) {
            input.value = "";
          }
        }
      });
    },
    _createField: function (fieldData) {
      var field;
      switch (fieldData.type) {
        case "email":
          field = new EmailField(fieldData);
          break;
        case "captcha":
          field = new CaptchaField(fieldData);
          break;
        case "address":
          field = new AddressField(fieldData);
          break;
        case "birthday":
          field = new BirthdayField(fieldData);
          break;
        case "date":
          field = new DateField(fieldData);
          break;
        case "smsphone":
          field = new SmsPhoneField(fieldData);
          break;
        case "phone":
          field = fieldData.phoneformat === "US" ? new PhoneField(fieldData) : new TextField(fieldData);
          break;
        case "number":
          field = new NumberField(fieldData);
          break;
        case "select":
        case "dropdown":
          field = new SelectField(fieldData);
          break;
        case "hidden":
          field = new HiddenField(fieldData);
          break;
        case "radio":
        case "checkbox":
          if (fieldData.marketing_preference_id) {
            field = new GdprCheckboxField(fieldData);
          } else {
            field = new RadioCheckboxField(fieldData);
          }
          break;
        case "url":
        case "image":
          field = new UrlField(fieldData);
          break;
        case "text":
        default:
          field = new TextField(fieldData);
      }
      if (field) {
        this.fieldNodes.push(field);
      }
      return field;
    },
    _teardownFormWithMessage: function (message) {
      // Make a form success response div if one doesn't already exist
      var formSuccessNode = query(".signup-success", this.formResponseMessages)[0];
      if (!formSuccessNode) {
        formSuccessNode = domConstruct.place('<div class="signup-success"></div>', this.formResponseMessages);
      }
      var formErrorsNode = query(".flash-errors", this.formResponseMessages)[0];
      if (formErrorsNode) {
        domStyle.set(formErrorsNode, "display", "none");
      }
      if (this.gdprContent) {
        this.gdprContent.set("errorMessage", "");
      }

      // Reset the form
      this.formNode.reset();

      // Reset inline field validation
      array.forEach(this.fieldNodes, function (input) {
        input.resetField();
      });

      // Hide the form
      domStyle.set(this.formContentContainer, "display", "none");
      html.set(formSuccessNode, message);
    },
    _handleRedirect: function (url) {
      var linkUrl = domConstruct.create("a", {
        href: url
      });
      domConstruct.place(document.createTextNode(url), linkUrl);
      var redirectMessage = "Success! You will now be redirected to " + linkUrl.outerHTML;
      var redirectPreviewMessage = "Success! After the signup form is submitted, visitors will be sent to " + url;
      if (this.isPreview) {
        var toaster = new Toaster();
        toaster.setContent(redirectPreviewMessage, "message");
        toaster.placeAt(document.querySelector("body"));
        return;
      }
      this._teardownFormWithMessage(redirectMessage);
      window.location = url;
    },
    _handleSuccessResponse: function (response) {
      if (window.mc_process_engagement_post_signup) {
        window.mc_process_engagement_post_signup();
      }
      // Show confirmation message after signup
      if (this.config.successAction === "message") {
        this._teardownFormWithMessage(response.msg);
        return;
      }

      // Redirect users after signup
      if (this.config.successAction === "redirect") {
        var redirectUrl = this.config.successRedirectUrl;
        this._handleRedirect(redirectUrl);
      }
    },
    _handleErrorResponse: function (response) {
      if (!response) {
        return;
      }
      // Reset GDPR error messaging
      if (this.gdprContent) {
        this.gdprContent.set("errorMessage", "");
      }

      // Hide form success response div if exists
      var formSuccessNode = query(".signup-success", this.formResponseMessages)[0];
      if (formSuccessNode) {
        domStyle.set(formSuccessNode, "display", "none");
      }

      // Display form error if one exists
      if (response.msg) {
        // Allow error message to be overwriten
        var flashMessage = response.msg;
        if (this.gdprContent && response.type === "GDPR") {
          flashMessage = "Something went wrong. Fix the errors to subscribe.";
          this.gdprContent.set("errorMessage", response.msg);
        }
        var formErrorsNode = "<div class=\"flash-errors\">" + flashMessage + "</div>";
        domConstruct.place(formErrorsNode, this.formResponseMessages, "only");
      }

      // Display any field-specific error messages inline
      if (response.errors) {
        array.forEach(this.fieldNodes, function (input) {
          if (response.errors.hasOwnProperty(input.merge_id)) {
            var msg = response.errors[input.merge_id];
            // Age-gating: replace server's "SMS Merge Field" copy with the friendlier required-field message.
            if (input.validateAsType === "smsphone" && (input.includeAgeGatingDob || input.ageGatingEnabled) && msg === "The SMS Merge Field is required.") {
              msg = translations["9303c9bd4f8178680dc382adbfcd62af"];
            }
            input.setFieldAsInvalid(msg);
          } else if (response.errors.hasOwnProperty(input.type)) {
            input.setFieldAsInvalid(response.errors[input.type]);
          } else {
            input.setFieldAsValid();
          }
        });
        var dobErrorKey = "mc_age_gating_dob";
        var dobField = null;
        array.forEach(this.fieldNodes, function (f) {
          if (f._dobInputNode) {
            dobField = f;
          }
        });
        if (dobField) {
          if (response.errors.hasOwnProperty(dobErrorKey)) {
            dobField._dobInputNode.classList.add("invalid");
            dobField._dobInputNode.classList.remove("valid");
            if (dobField._dobErrorNode) {
              dobField._dobErrorNode.innerHTML = response.errors[dobErrorKey];
              dobField._dobErrorNode.style.display = "block";
            }
          } else {
            dobField._dobInputNode.classList.remove("invalid");
            dobField._dobInputNode.classList.add("valid");
            if (dobField._dobErrorNode) {
              dobField._dobErrorNode.style.display = "none";
            }
          }
        } else if (this.config.dobErrorFallbackEnabled && response.errors.hasOwnProperty(dobErrorKey) && !response.msg) {
          // No DOB input is rendered, so surface the error at form level instead of dropping it.
          var dobFlashNode = domConstruct.create("div", {
            "class": "flash-errors"
          });
          dobFlashNode.textContent = response.errors[dobErrorKey];
          domConstruct.place(dobFlashNode, this.formResponseMessages, "only");
        }
      }
      if (this.captchaEnabled) {
        // eslint-disable-next-line no-undef
        grecaptcha.reset();
      }
    },
    toHTML: function () {
      return this.domNode.outerHTML;
    },
    loadCaptchaJs: function () {
      var captchaDeferred = new Deferred();
      var captcha = document.createElement("script");
      captcha.type = "text/javascript";
      captcha.src = "https://www.google.com/recaptcha/api.js";
      on(captcha, "load", lang.hitch(this, function () {
        var timer = setInterval(function () {
          var recaptchaLoaded = typeof grecaptcha !== "undefined"
          // eslint-disable-next-line no-undef
          && typeof grecaptcha.render !== "undefined"
          // eslint-disable-next-line no-undef
          && typeof grecaptcha.execute !== "undefined"
          // eslint-disable-next-line no-undef
          && typeof grecaptcha.reset !== "undefined";
          if (recaptchaLoaded) {
            clearInterval(timer);
            captchaDeferred.resolve();
          }
        }, 100);
      }));
      document.getElementsByTagName("head")[0].appendChild(captcha);
      return captchaDeferred.promise;
    },
    loadCustomCss: function () {
      if (this.customCssNode) {
        domConstruct.destroy(this.customCssNode);
      }
      var customDeferred = new Deferred();
      this.customCssNode = this.createStyleNode(document);
      var sheet = this.getStyleSheet(this.customCssNode);
      if (this.styles.hasOwnProperty("neapolitan")) {
        this.styles.neapolitan.forEach(function (style) {
          var props = Object.keys(style.props);
          props.forEach(function (prop) {
            this.addCSSRule(sheet, style.selector, prop + ": " + style.props[prop].value + ";");
          }.bind(this));
        }.bind(this));

        // add button alignment and button styles??
        if (this.styles.hasOwnProperty("formStyles")) {
          for (var formButtonStyle in this.styles.formStyles) {
            if (this.styles.formStyles.hasOwnProperty(formButtonStyle)) {
              this._addAlignmentStyles(this, sheet, this.styles.formStyles, formButtonStyle);
            }
          }
        }
      } else {
        // should never be in a state where neapolitan doesn't exist without the flag.
        // when we turn the flag off, on style with neapolitan styles when they exist
        // only for button and label, not neapolitan and formStyles in formConfig.styles
        if (this.styles.hasOwnProperty("button")) {
          // _addButtonStyles
          this._addButtonStyles(this, sheet, this.config.styles, "button");
        }
        if (this.styles.hasOwnProperty("labels")) {
          // _addLabelStyles
          this._addLabelStyles(this, sheet, this.config.styles, "labels");
        }
      }
      customDeferred.resolve();
      return customDeferred.promise;
    },
    /**
     * _addButtonStyles
     * @param {Object} signupFormContainer is the module object
     * @param {Object} sheet is the stylesheet to which to add style
     * @param {Object} stylesInFormConf is the formConfig style object to process specific styled elements
     * @param {String} domElKey is the object key for which DOM element is represented
     */
    _addButtonStyles: function (signupFormContainer, sheet, stylesInFormConf, domElKey) {
      // addCSSRule from _CustomStyleRulesMixin
      for (var domElProp in stylesInFormConf[domElKey]) {
        if (stylesInFormConf[domElKey].hasOwnProperty(domElProp)) {
          switch (domElProp) {
            case "color":
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "background-color:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            case "hover_color":
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button:hover", "background-color:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            case "text_color":
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "color:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            case "border":
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "border:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            case "alignment":
              if (stylesInFormConf[domElKey][domElProp] === "right") {
                signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:right;");
              } else if (stylesInFormConf[domElKey][domElProp] === "center") {
                signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:none;margin-left:auto;margin-right:auto;");
                if (has("ie") <= 9) {
                  signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "display:table-cell;");
                  signupFormContainer.addCSSRule(sheet, ".webContent__content .content__button", "margin-left:auto;margin-right:auto;display:table;");
                } else {
                  signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "display:table;");
                }
              } else {
                signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:left;");
              }
              break;
            case "style":
              if (stylesInFormConf[domElKey][domElProp] === "full") {
                signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "width:100%;");
              } else {
                signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "width:auto;");
              }
              break;
            default:
              break;
          }
          // add max-width on container but old style
          signupFormContainer.addCSSRule(sheet, ".mcnSignUpFormContentContainer", "max-width: 450px");
        }
      }
    },
    /**
     * _addLabelStyles
     * @param {Object} signupFormContainer is the module object
     * @param {Object} sheet is the stylesheet to which to add style
     * @param {Object} stylesInFormConf is the formConfig style object to process specific styled elements
     * @param {String} domElKey is the object key for which DOM element is represented
     */
    _addLabelStyles: function (signupFormContainer, sheet, stylesInFormConf, domElKey) {
      // addCSSRule from _CustomStyleRulesMixin
      for (var domElProp in stylesInFormConf[domElKey]) {
        if (stylesInFormConf[domElKey].hasOwnProperty(domElProp)) {
          switch (domElProp) {
            case "color":
              signupFormContainer.addCSSRule(sheet, ".webContent__content label", "color:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            case "font":
              signupFormContainer.addCSSRule(sheet, ".webContent__content label", "font-family:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            default:
              break;
          }
        }
      }
    },
    /**
     * _addAlignmentStyles
     * @param {Object} signupFormContainer is the module object
     * @param {Object} sheet is the stylesheet to which to add style
     * @param {Object} stylesInFormConf is the formConfig style object to process specific styled elements
     * @param {String} domElKey is the object key for which DOM element is represented2
     */
    _addAlignmentStyles: function (signupFormContainer, sheet, stylesInFormConf, domElKey) {
      // addCSSRule from _CustomStyleRulesMixin
      switch (domElKey) {
        case "buttonAlignment":
          if (stylesInFormConf[domElKey] === "right") {
            signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:right;");
          } else if (stylesInFormConf[domElKey] === "center") {
            signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:none;margin-left:auto;margin-right:auto;");
            if (has("ie") <= 9) {
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "display:table-cell;");
              signupFormContainer.addCSSRule(sheet, ".content__button", "margin-left:auto;margin-right:auto;display:table;");
            } else {
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "display:table;");
            }
          } else {
            signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:left;");
          }
          break;
        case "buttonWidthStyle":
          if (stylesInFormConf[domElKey] === "full") {
            signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "width:100%;");
          }
          break;
        case "formWidth":
          signupFormContainer.addCSSRule(sheet, ".mcnSignUpFormContentContainer", "flex:0 0 " + stylesInFormConf[domElKey]);
          break;
        default:
          break;
      }
    }
  });
});
if (typeof window !== "undefined") {
  if (!window.MC) {
    window.MC = {};
  }
  window.MC.updateSelectedFlag = function (selectElement, europeanSmsExpansionEnabled) {
    var selectedOption = selectElement.options[selectElement.selectedIndex];
    var flag = selectedOption.getAttribute("data-flag");
    var countryCode = selectedOption.value;
    (function syncAgeGatingDobWithSmsCountry(cc) {
      var hid = document.querySelector('input[type="hidden"][name="MC_AGE_GATING_DOB_country"]');
      var txt = document.querySelector("input.age-gating-dob-input");
      if (!hid && !txt) {
        return;
      }
      var code = cc || "";
      if (hid) {
        hid.value = code;
      }
      if (txt) {
        var fmt = String(code).toUpperCase() === "US" ? "MM/DD/YYYY" : "DD/MM/YYYY";
        var prevFmt = txt.getAttribute("data-date-format");
        txt.setAttribute("data-date-format", fmt);
        txt.placeholder = fmt;
        if (prevFmt && prevFmt !== fmt) {
          txt.value = "";
        }
      }
    })(countryCode);
    var prefix = selectedOption.getAttribute("data-calling-code");
    var callingCodeHelpText = document.getElementById("calling-code-help-text");
    if (callingCodeHelpText && selectedOption.getAttribute("data-calling-code")) {
      var selectedCountryCallingCode = selectedOption.getAttribute("data-calling-code");
      callingCodeHelpText.textContent = selectedCountryCallingCode;
    }
    var fieldName = selectElement.id.replace("country-select-", "");
    var flagSpan = document.getElementById("flag-" + fieldName);
    if (flagSpan && flag) {
      flagSpan.textContent = flag;
    }

    // Update placeholder
    var phoneInput = document.getElementById(fieldName);
    if (phoneInput) {
      var mockPlaceholders;
      if (europeanSmsExpansionEnabled) {
        mockPlaceholders = [{
          countryCode: "US",
          placeholder: "+1 000 000 0000",
          helpText: "Include the US country code +1 before the phone number"
        }, {
          countryCode: "GB",
          placeholder: "+44 0000 000000",
          helpText: "Include the GB country code +44 before the phone number"
        }, {
          countryCode: "CA",
          placeholder: "+1 000 000 0000",
          helpText: "Include the CA country code +1 before the phone number"
        }, {
          countryCode: "AU",
          placeholder: "+61 000 000 000",
          helpText: "Include the AU country code +61 before the phone number"
        }, {
          countryCode: "DE",
          placeholder: "+49 000 0000000",
          helpText: "Fügen Sie vor der Telefonnummer die DE-Ländervorwahl +49 ein"
        }, {
          countryCode: "FR",
          placeholder: "+33 0 00 00 00 00",
          helpText: "Incluez le code pays FR +33 avant le numéro de téléphone"
        }, {
          countryCode: "ES",
          placeholder: "+34 000 000 000",
          helpText: "Incluya el código de país ES +34 antes del número de teléfono"
        }, {
          countryCode: "NL",
          placeholder: "+31 0 00000000",
          helpText: "Voeg de NL-landcode +31 toe vóór het telefoonnummer"
        }, {
          countryCode: "BE",
          placeholder: "+32 000 00 00 00",
          helpText: "Incluez le code pays BE +32 avant le numéro de téléphone"
        }, {
          countryCode: "CH",
          placeholder: "+41 00 000 00 00",
          helpText: "Fügen Sie vor der Telefonnummer die CH-Ländervorwahl +41 ein"
        }, {
          countryCode: "AT",
          placeholder: "+43 000 000 0000",
          helpText: "Fügen Sie vor der Telefonnummer die AT-Ländervorwahl +43 ein"
        }, {
          countryCode: "IE",
          placeholder: "+353 00 000 0000",
          helpText: "Include the IE country code +353 before the phone number"
        }, {
          countryCode: "IT",
          placeholder: "+39 000 000 0000",
          helpText: "Includere il prefisso internazionale IT +39 prima del numero di telefono"
        },
        // New European SMS Expansion countries
        {
          countryCode: "NO",
          placeholder: "+47 000 00 000",
          helpText: "Inkluder NO landskode +47 før telefonnummeret"
        }, {
          countryCode: "SE",
          placeholder: "+46 00 000 00 00",
          helpText: "Inkludera SE landskod +46 före telefonnumret"
        }, {
          countryCode: "DK",
          placeholder: "+45 00 00 00 00",
          helpText: "Inkluder DK landekode +45 før telefonnummeret"
        }, {
          countryCode: "FI",
          placeholder: "+358 00 000 0000",
          helpText: "Sisällytä FI-maakoodi +358 ennen puhelinnumeroa"
        }, {
          countryCode: "EE",
          placeholder: "+372 0000 0000",
          helpText: "Lisage EE riigikood +372 telefoninumbri ette"
        }, {
          countryCode: "PL",
          placeholder: "+48 000 000 000",
          helpText: "Podaj numer kierunkowy PL +48 przed numerem telefonu"
        }, {
          countryCode: "SK",
          placeholder: "+421 000 000 000",
          helpText: "Pred telefónne číslo uveďte kód krajiny SK +421"
        }, {
          countryCode: "LV",
          placeholder: "+371 0000 0000",
          helpText: "Iekļaujiet LV valsts kodu +371 pirms tālruņa numura"
        }, {
          countryCode: "LT",
          placeholder: "+370 0000 0000",
          helpText: "Įtraukite LT šalies kodą +370 prieš telefono numerį"
        }, {
          countryCode: "GR",
          placeholder: "+30 000 000 0000",
          helpText: "Συμπεριλάβετε τον κωδικό χώρας GR +30 πριν από τον αριθμό τηλεφώνου"
        }, {
          countryCode: "PT",
          placeholder: "+351 000 000 000",
          helpText: "Inclua o código de país PT +351 antes do número de telefone"
        }, {
          countryCode: "HR",
          placeholder: "+385 00 000 0000",
          helpText: "Uključite HR pozivni broj države +385 prije telefonskog broja"
        }, {
          countryCode: "SI",
          placeholder: "+386 00 000 000",
          helpText: "Vključite SI kodo države +386 pred telefonsko številko"
        }, {
          countryCode: "IS",
          placeholder: "+354 000 0000",
          helpText: "Láttu IS landsnúmer +354 fylgja á undan símanúmerinu"
        }, {
          countryCode: "LU",
          placeholder: "+352 000 000 000",
          helpText: "Incluez le code pays LU +352 avant le numéro de téléphone"
        }, {
          countryCode: "MC",
          placeholder: "+377 00 00 00 00",
          helpText: "Incluez le code pays MC +377 avant le numéro de téléphone"
        }, {
          countryCode: "AD",
          placeholder: "+376 000 000",
          helpText: "Incloeu el codi de país AD +376 abans del número de telèfon"
        }, {
          countryCode: "JE",
          placeholder: "+44 0000 000000",
          helpText: "Include the JE country code +44 before the phone number"
        }, {
          countryCode: "IM",
          placeholder: "+44 0000 000000",
          helpText: "Include the IM country code +44 before the phone number"
        }, {
          countryCode: "GG",
          placeholder: "+44 0000 000000",
          helpText: "Include the GG country code +44 before the phone number"
        }, {
          countryCode: "AL",
          placeholder: "+355 00 000 0000",
          helpText: "Përfshini kodin e vendit AL +355 para numrit të telefonit"
        }, {
          countryCode: "SM",
          placeholder: "+378 0000 000000",
          helpText: "Includere il prefisso internazionale SM +378 prima del numero di telefono"
        }, {
          countryCode: "FO",
          placeholder: "+298 000000",
          helpText: "Inkluder FO landekode +298 før telefonnummeret"
        }, {
          countryCode: "MT",
          placeholder: "+356 0000 0000",
          helpText: "Include the MT country code +356 before the phone number"
        }, {
          countryCode: "LI",
          placeholder: "+423 000 0000",
          helpText: "Fügen Sie vor der Telefonnummer die LI-Ländervorwahl +423 ein"
        }, {
          countryCode: "GI",
          placeholder: "+350 000 00000",
          helpText: "Include the GI country code +350 before the phone number"
        }, {
          countryCode: "MD",
          placeholder: "+373 00 000 000",
          helpText: "Includeți codul de țară MD +373 înaintea numărului de telefon"
        }, {
          countryCode: "HU",
          placeholder: "+36 00 000 0000",
          helpText: "A telefonszám előtt adja meg a HU országkódot +36"
        }, {
          countryCode: "NZ",
          placeholder: "+64 00 000 0000",
          helpText: "Include the NZ country code +64 before the phone number"
        }, {
          countryCode: "ME",
          placeholder: "+382 00 000 000",
          helpText: "Uključite ME pozivni broj države +382 prije telefonskog broja"
        }];
      } else {
        mockPlaceholders = [{
          countryCode: "US",
          placeholder: "+1 000 000 0000",
          helpText: "Include the US country code +1 before the phone number"
        }, {
          countryCode: "GB",
          placeholder: "+44 0000 000000",
          helpText: "Include the GB country code +44 before the phone number"
        }, {
          countryCode: "CA",
          placeholder: "+1 000 000 0000",
          helpText: "Include the CA country code +1 before the phone number"
        }, {
          countryCode: "AU",
          placeholder: "+61 000 000 000",
          helpText: "Include the AU country code +61 before the phone number"
        }, {
          countryCode: "DE",
          placeholder: "+49 000 0000000",
          helpText: "Fügen Sie vor der Telefonnummer die DE-Ländervorwahl +49 ein"
        }, {
          countryCode: "FR",
          placeholder: "+33 0 00 00 00 00",
          helpText: "Incluez le code pays FR +33 avant le numéro de téléphone"
        }, {
          countryCode: "ES",
          placeholder: "+34 000 000 000",
          helpText: "Incluya el código de país ES +34 antes del número de teléfono"
        }, {
          countryCode: "NL",
          placeholder: "+31 0 00000000",
          helpText: "Voeg de NL-landcode +31 toe vóór het telefoonnummer"
        }, {
          countryCode: "BE",
          placeholder: "+32 000 00 00 00",
          helpText: "Incluez le code pays BE +32 avant le numéro de téléphone"
        }, {
          countryCode: "CH",
          placeholder: "+41 00 000 00 00",
          helpText: "Fügen Sie vor der Telefonnummer die CH-Ländervorwahl +41 ein"
        }, {
          countryCode: "AT",
          placeholder: "+43 000 000 0000",
          helpText: "Fügen Sie vor der Telefonnummer die AT-Ländervorwahl +43 ein"
        }, {
          countryCode: "IE",
          placeholder: "+353 00 000 0000",
          helpText: "Include the IE country code +353 before the phone number"
        }, {
          countryCode: "IT",
          placeholder: "+39 000 000 0000",
          helpText: "Includere il prefisso internazionale IT +39 prima del numero di telefono"
        }];
      }
      var selectedPlaceholder = mockPlaceholders.find(function (item) {
        return item.countryCode === countryCode;
      });
      var placeholderText = selectedPlaceholder ? selectedPlaceholder.placeholder : mockPlaceholders[0].placeholder;
      phoneInput.placeholder = placeholderText;
      var smsNotRequiredRemoveCountryCodeEnabled = window.MC.smsNotRequiredRemoveCountryCodeEnabled || false;
      var isRequired = window.MC.required || false;
      var shouldAppendCountryCode = smsNotRequiredRemoveCountryCodeEnabled ? isRequired : true;
      // Update the input value with the new country code prefix (readonly)
      if (prefix) {
        var currentValue = phoneInput.value.trim();
        // Remove the old country code prefix if present
        if (currentValue.match(/^\+\d+/)) {
          currentValue = currentValue.replace(/^\+\d+\s*/, "");
        }
        // Set value to new country code + any remaining phone number
        var newPrefix = prefix + " ";
        phoneInput.value = newPrefix + currentValue;

        // Update the prefix attributes for readonly protection
        phoneInput.setAttribute("data-prefix-length", newPrefix.length);
        phoneInput.setAttribute("data-current-prefix", newPrefix);
        // if (window.MC.formsMultiCountryFastFollowsEnabled && prefix && shouldAppendCountryCode) {
        //     phoneInput.value = prefix;
        // }
        // Move cursor to end of input
        phoneInput.setSelectionRange(phoneInput.value.length, phoneInput.value.length);
      }
      var helpTextSpan = document.getElementById("help-text");
      // Hide the help text if multi-country fast follows is enabled.
      if (!window.MC.formsMultiCountryFastFollowsEnabled && helpTextSpan) {
        var selectedHelpText = mockPlaceholders.find(function (item) {
          return item.countryCode === countryCode;
        });
        var helpText = selectedHelpText ? selectedHelpText.helpText : mockPlaceholders[0].helpText;
        helpTextSpan.textContent = helpText;
      }
    }

    // Find template from SMS program data based on country code
    if (countryCode && window.MC.smsProgramData && Array.isArray(window.MC.smsProgramData)) {
      if (window.MC.legaleseVersionCaptureAndSaveEnabled) {
        var browserLang = window.navigator && window.navigator.language ? window.navigator.language.split("-")[0].toLowerCase() : "en";
        var entriesForCountry = window.MC.smsProgramData.filter(function (p) {
          return p && p.countryCode === countryCode;
        });
        var matchedProgram = null;
        if (entriesForCountry.length > 0) {
          matchedProgram = entriesForCountry.find(function (p) {
            return (p.language || "").toLowerCase() === browserLang;
          }) || entriesForCountry.find(function (p) {
            return (p.language || "").toLowerCase() === "en";
          }) || entriesForCountry[0];
        }
        if (matchedProgram) {
          var consentTpl = window.MC.required ? matchedProgram.requiredTemplate : matchedProgram.optionalTemplate;
          if (consentTpl) {
            var legalElId = window.MC.required ? "sms-legal-text-required" : "sms-legal-text-optional";
            var legalEl = document.getElementById(legalElId);
            if (legalEl) {
              legalEl.innerHTML = consentTpl;
            }
          }
        }
        return;
      }
      for (var i = 0; i < window.MC.smsProgramData.length; i++) {
        if (window.MC.smsProgramData[i].countryCode === countryCode) {
          var template = window.MC.required ? window.MC.smsProgramData[i].requiredTemplate : window.MC.smsProgramData[i].optionalTemplate;
          if (template) {
            var smsLegalElementId = window.MC.required ? "sms-legal-text-required" : "sms-legal-text-optional";
            var smsLegalElement = document.getElementById(smsLegalElementId);
            if (smsLegalElement) {
              smsLegalElement.innerHTML = template;
            }
          }
          break;
        }
      }
    }
  };
}